export const centersData = [
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Aarya Bhavan",
     "CENTER_ADDRESS": "Back Of Srk Engeering College(Enkapadu)",
     "PINCODE": 521108,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Raman Bhavna-5",
     "CENTER_ADDRESS": "Opposite Tata Company(Gudavalli)",
     "PINCODE": 522104,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Santha Bhavan",
     "CENTER_ADDRESS": "Opposite Volvo Show Room(Gudavalli)",
     "PINCODE": 522104,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Elite China",
     "CENTER_ADDRESS": "Gudavalli Center",
     "PINCODE": 522104,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Raman Bhavn-2",
     "CENTER_ADDRESS": "Near Model Dairy(Gudavalli)",
     "PINCODE": 522104,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Raman Bhavn-1",
     "CENTER_ADDRESS": "Near Model Dairy(Gudavalli)",
     "PINCODE": 522104,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sumedha Bhavan",
     "CENTER_ADDRESS": "Kesarapalli \n(Near Djr College)",
     "PINCODE": 521102,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Mayuri-2(Rb-3)",
     "CENTER_ADDRESS": "Opposite Blue Dart,Near Model Dairy(Gudavalli)",
     "PINCODE": 522104,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Cnpl-4(Raman Bhavan-4)",
     "CENTER_ADDRESS": "Opposite Blue Dart,Near Model Dairy(Gudavalli)",
     "PINCODE": 522104,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Mayuri Bhavan",
     "CENTER_ADDRESS": "100 Feet Road Opp Kamineni Hospital",
     "PINCODE": 521134,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Ramakrishna Bhavan",
     "CENTER_ADDRESS": "Saipuram Colony,\n1Center Golapudi",
     "PINCODE": 521225,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sarada Nilayam",
     "CENTER_ADDRESS": "Sri Vybhavi3, Salipeta Road, Penamaluru",
     "PINCODE": 521137,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Saraswathi ",
     "CENTER_ADDRESS": "Chaitanya Nagar, 100 Feet Road, Poranki.",
     "PINCODE": 521137,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Vagdevi",
     "CENTER_ADDRESS": "Chaitanya Nagar, 100 Feet Road, Poranki.",
     "PINCODE": 521137,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sri Mythryee",
     "CENTER_ADDRESS": "Bandar Road, Near Chepala Kundilu Center,Ganguru.",
     "PINCODE": 521139,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sri Prada (Edupugallu)",
     "CENTER_ADDRESS": "Bandar Road, Opp Nalanda School, Eedupugallu.",
     "PINCODE": 521151,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sri Vybhavi 1",
     "CENTER_ADDRESS": "Near Sri Chaitanyatechno School Punadipadu.",
     "PINCODE": 521151,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sri Vybhavi 2",
     "CENTER_ADDRESS": "Near Sri Chaitanyatechno School Punadipadu.",
     "PINCODE": 521151,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sri Vybhavi Aiims",
     "CENTER_ADDRESS": "Near Sri Chaitanyatechno School Punadipadu.",
     "PINCODE": 521151,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sri Vasista",
     "CENTER_ADDRESS": "Near Sri Chaitanyatechno School Punadipadu.",
     "PINCODE": 521151,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sri Pradha",
     "CENTER_ADDRESS": "Near Sri Chaitanyatechno School Punadipadu.",
     "PINCODE": 521151,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Bhardwaja",
     "CENTER_ADDRESS": "Near Sri Chaitanyatechno School Punadipadu.",
     "PINCODE": 521151,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Vedavyas",
     "CENTER_ADDRESS": "Bandar Road, Gosala",
     "PINCODE": 521151,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Indra Towers",
     "CENTER_ADDRESS": "Usha Land Mark, Opp. M&M Showroom, Mg Road",
     "PINCODE": 520010,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Maheswara Bhavan",
     "CENTER_ADDRESS": "Maheswara Bhavan, Opp. Hdfc Bank, Mg Road ",
     "PINCODE": 520010,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Eswari Nilayam",
     "CENTER_ADDRESS": "Krishnaveni Campus, Beside Eenadu Office",
     "PINCODE": 520010,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sri Bhaskar Bhavan",
     "CENTER_ADDRESS": "Sheds Campus, Beside Eenadu Office",
     "PINCODE": 520010,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Rabindranath Tagore Bhavan",
     "CENTER_ADDRESS": "D.No. 32-27-9\/1, Sarvodaya Vidya Peet St Chuttugunta, Maruthi Nagar, Vijayawada",
     "PINCODE": 520002,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Vuyyuru",
     "CENTER_ADDRESS": "Sri Chaitanya Jr College, Opp. Deepak Mahal Katuru Road, Beside Care Hospital",
     "PINCODE": 521165,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Gudivada",
     "CENTER": "Gudivada",
     "CENTER_ADDRESS": "8\/191, Sri Ram Puram Colony, Old Current Office, Beside Fish Market Road, Satyanarayana Puram, Gudivada",
     "PINCODE": 521301,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sri Bhavani Nilayam",
     "CENTER_ADDRESS": "Sri Sai Saraswathi Nilayam,  Swathi Theater Crombaay Road, Bhavani Puram",
     "PINCODE": 520012,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Mangalagiri",
     "CENTER_ADDRESS": "Sri Chaitanya Jr College,  D.No.7-426 & 7-426\/A, Tipparla Bazar, Mangalagiri",
     "PINCODE": 522203,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Machilipatnam",
     "CENTER": "Machilipatnam",
     "CENTER_ADDRESS": "Sri Chaitanya Jr College, Ramanaidu Peta, Shaik Imam Street, Machilipatnam",
     "PINCODE": 521001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Eluru",
     "CENTER": "Eluru",
     "CENTER_ADDRESS": "Main Campus- Eluru, Marghadarshi Road, Narasimha Rao Peta, Eluru",
     "PINCODE": 534006,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Arundhathi",
     "CENTER_ADDRESS": "Sri Chaitanya Jr College,Nh 40, Opposite Safa Engineering College, Near Kranti Godown, B.Thandrapadu, Kurnool",
     "PINCODE": 518002,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Bhageeratha Bhavan",
     "CENTER_ADDRESS": "Sri Chaitanya Jr College,Nh 40, Opposite Safa Engineering College, Near Kranti Godown, B.Thandrapadu, Kurnool",
     "PINCODE": 518002,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Saraswathi Bhavan Knl",
     "CENTER_ADDRESS": "Sri Chaitanya Jr College,Opposite Hotel Hyderabad Chefs, Venkannabavi, Dinnedevarapadu, Kurnool 518002",
     "PINCODE": 518002,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Sri Bramarambika Bhavan Girls",
     "CENTER_ADDRESS": "Sri Chaitanya Jr College, Opposite Rayalaseema University, Pasupula Road, Kurnool 518002",
     "PINCODE": 518002,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Sri Guru Raghavendra Bhavan Boys",
     "CENTER_ADDRESS": "Sri Chaitanya Jr College,Nh 40, Opposite Safa Engineering College, Near Kranti Godown, B.Thandrapadu, Kurnool",
     "PINCODE": 518002,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool Campus",
     "CENTER_ADDRESS": "Sri Chaitanya Jr College,D.No 40-304, Beside Rr Hospital, Near Mourya Inn, Bhagya Nagar, Kurnool 518002",
     "PINCODE": 518004,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Krishnaveni Bhavan",
     "CENTER_ADDRESS": "Near Rtc Bustand,Beside Dwaraka Petrol Bunk,Khaja Nagar,Anantapur ",
     "PINCODE": 515001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Anantapur",
     "CENTER_ADDRESS": "Opp Devi Nursing  Home,Adimurthy Nagar,Anantapur",
     "PINCODE": 515001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Amalapuram",
     "CENTER": "Sri Shirdi Sai Campus",
     "CENTER_ADDRESS": "Sri Shirdi Sai Campus\n#1-5-58\/2A\nOngc Bypass Road, Savaram\nAmalapuram- 533201",
     "PINCODE": 533201,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Raman Bhavan 1\nSaraswathi Sowdham",
     "CENTER_ADDRESS": "Saraswathi Sowdham,\n#3-16A-101, Lakshminarayana\nNagar,Kakinada\n-533003",
     "PINCODE": 533003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Raman Bhavan 1\nRaman Bhavan 1 Building",
     "CENTER_ADDRESS": "#3-18-172\/6, Lakshminarayana Nagar, Kakinada-533003",
     "PINCODE": 533003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Bharathi Bhavan\nBharathi Bhavan Building",
     "CENTER_ADDRESS": "Near Sri Chaitanya Techno School,\n# 3-16E-2A, Lakshminarayana\nNagar,Kakinada\n-533003",
     "PINCODE": 533003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Bharathi Bhavan\nViyanthi Bhavan Building",
     "CENTER_ADDRESS": "Flat No:61, 3-16B-56\/1, Santhi Nagar, Foundation Hospital Kakinada -533003",
     "PINCODE": 533003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Kakinada Campus",
     "CENTER_ADDRESS": "#2-17D-3\/6, Venkat Nagar, Kakinada -533003",
     "PINCODE": 533003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Palakol",
     "CENTER": "Saraswathi Sowdham",
     "CENTER_ADDRESS": "Saraswathi Soudham Campus\nBrodipet, Brodipet Bipass\nRoad, Palakollu, West\nGodavari - 534260",
     "PINCODE": 534260,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Saraswathi Bhavan",
     "CENTER_ADDRESS": "#3-307,308-Sai Gardens, Morampudi, Rajamahendravaram-533107",
     "PINCODE": 533107,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Saraswathi Bhavan 2",
     "CENTER_ADDRESS": "#32\/7, 31\/18, Near Pittlavarni Cheru, Venkata Swaraswamy Temple, Navaram Road, Morampudi-533017",
     "PINCODE": 533107,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Razole",
     "CENTER": "Saraswathi Sowdham",
     "CENTER_ADDRESS": "Saraswathi Soudham Campus\n#9-60\/1,Opp.Rtc Complex,\nRazole-533242",
     "PINCODE": 533242,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tuni",
     "CENTER": "Saraswathi Sowdham",
     "CENTER_ADDRESS": "Saraswathi Soudham Campus\n#3-41-8\/4, Sriram Nagar, Mr\nPeta, Tuni- 533401",
     "PINCODE": 533401,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Saraswathi Soudham",
     "CENTER_ADDRESS": "Sri Chaitanya Junior College\nD.No: 85-6-15\/1,Routhu Plaza, Vl Puram,Rajamahendravaram ",
     "PINCODE": "533 103",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Sarvani Towers",
     "CENTER_ADDRESS": "Sri Chaitanya Junior College,\nD.No:75-1-4,Prakash Nagar, Rajamahendravaram",
     "PINCODE": "533 101",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Vyas Bhavan",
     "CENTER_ADDRESS": "Sri Chaitanya Junior College\nD.No: 14-137\/A,Opp Rtc Complex,Behind Union Bank, Rajamahendravaram - 533 103",
     "PINCODE": "533 103",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Sri Vybhavi",
     "CENTER_ADDRESS": "Sri Chaitanya Junior College\nD.No:78-10-7,Syamala Nagar , Beside Govindurajulu Hospital,Rajamahendravaram",
     "PINCODE": "533 103",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Kovvuru",
     "CENTER_ADDRESS": "Sri Chaitanya Junior College\nD.No:4-177,Vemuluru Road,Kovvuru",
     "PINCODE": "534 350",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Chittoor",
     "CENTER": "Chittor Campus",
     "CENTER_ADDRESS": "D.No-10-199, Tmr Tower , Gandhi Road,Oppt Lic Office, Chittoor,517001",
     "PINCODE": 517001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Sri Balaji Bhavan",
     "CENTER_ADDRESS": "Dono:1-399 Maruthi Nagar, Beside Kadapa Café, Kotireddy Circle Kadapa-516001",
     "PINCODE": 516001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Sri Sai Sadhan",
     "CENTER_ADDRESS": "D.No:42\/609-28, Ngos Colony, Apasara Circle , Kadapa",
     "PINCODE": 516001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Madanapalle",
     "CENTER": "Sri Ganga Sadhan",
     "CENTER_ADDRESS": "D.No: 3\/153-4-4-1, Hospital Branch , Beside Rtc Bus Stand,Madhanapalli-517325,Annamaiah (D)",
     "PINCODE": 517325,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Anjanadri Campus",
     "CENTER_ADDRESS": "D.No: 2-16,Telecom Colony Oteru Road ,Srinivasapuram ,Tirupathi-517503",
     "PINCODE": 517503,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Bashyam Campus",
     "CENTER_ADDRESS": "Beside Police Quarters, New Balaji Colony, Tirupathi-517501",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Cure Campus",
     "CENTER_ADDRESS": "D.No:6-2-83, Kt Road,Near Axis Bank Main Branch Tirupati - 517501",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Gayathri Towers  Thumalagunta",
     "CENTER_ADDRESS": "D. No: 19-1D Besie \nMahila Univarsity Upperpalli Road , Tummalagunta ,Tirupati (Rural)Pin Code 517502 ",
     "PINCODE": 517502,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Khazana Campus1",
     "CENTER_ADDRESS": "D No 3\/3 Uppsatirs Khazan.\nOpp Muncipal Office \nVv Mahal Road \nTirupath Pin 517501",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Khazana Campus2",
     "CENTER_ADDRESS": "Pmr Complex, Opp Megha Medicals , Vv Mahal Rd, Tirupathi - 517501",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Main Campus Days ",
     "CENTER_ADDRESS": "\nDo; No 25, Gandhi Road  \nMunicipal Complex \nPin No; 517501",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Main Ii Campus",
     "CENTER_ADDRESS": "D No: 37 Agk Building \nGandhi Road\n Tirupathi Pin: 517501",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Padmavathi Thanapalli",
     "CENTER_ADDRESS": "Cherukuri Gardens,Tanapalli Road,\nNear Ramanaidu Kalyana Mandapam,\nTiruchanoor,Tirupati,517503",
     "PINCODE": 517503,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Padmavathi 2 Mr Palli Campus",
     "CENTER_ADDRESS": "Hathiramjicolony,\nBairagipateda,\nBack Side Radha Narayana Hospital,Pincode:517501",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Raman Bhavan",
     "CENTER_ADDRESS": " Rc Road\n Ebsr Complex Near \nAnnamayya Circle Tirupati Pin Code 517501",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Sarvani Sowdham",
     "CENTER_ADDRESS": "Mallagunta (V)\nRc Road\n Near Golden Vilas Oppsit\nPin  517502",
     "PINCODE": 517502,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Seshadri Towers Renigunta",
     "CENTER_ADDRESS": "D No: 195 , Stree No 620 ,\n Poolavanigunta ,Renigunta Road,\n Tirupathi ,Pin 517501",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Sri Lakshmi Bhavan",
     "CENTER_ADDRESS": "Old Volvo Show Room Backside\nTiruchanoor Road \nTirupati Pincode:517503",
     "PINCODE": 517503,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Sri Meenakshmi Sowdham",
     "CENTER_ADDRESS": "D.No. 489-2, Vidya Nagar,\nPerur,Tirupati ( Rural ) Pin   517503",
     "PINCODE": 517503,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Sri Sai Sowdham Boys(Tpt)",
     "CENTER_ADDRESS": "Rama Chandra Puram (M)\nChuttagunta Ramapuram (V)  \nTirupathi Pin Code 517561",
     "PINCODE": 517561,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Vasavi Bhavan Tr Boys",
     "CENTER_ADDRESS": "Plot No:10,Vasundara Nagar,Tiruchanoor,\nTirupati (R)-517503",
     "PINCODE": 517503,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Vedavyas Bhavan",
     "CENTER_ADDRESS": "Dr No:411\/2P  \n 150 By Pass Road, Tiruchanoor (V) \nTirupathi ( R)517503        ",
     "PINCODE": 517503,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Vignesh Towers",
     "CENTER_ADDRESS": "D.No:1-10,Sri Chaitanya College,Pudi Road,Tirupathi Rural Pin Code-517503",
     "PINCODE": 517503,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Vishnu Towers",
     "CENTER_ADDRESS": "D No:19-13-1\/1-5 Narayana Puram\nTirupathi,517501",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Venkatadri Bhavan",
     "CENTER_ADDRESS": "D No: 8-171-1, New Balaji Colony, Mr Palli, Tirupathi Pin-517502",
     "PINCODE": 517501,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Vedavyas Bhavan-3",
     "CENTER_ADDRESS": "D No:448\/P,4Th Line,Vasundhara Nagar,\nThiruchanur,Tirupathi,Pin:517503",
     "PINCODE": 517503,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Gayathri Bhavan",
     "CENTER_ADDRESS": "Vedayapalem ",
     "PINCODE": 524004,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Iskcon Dheeraj",
     "CENTER_ADDRESS": "Annamaya Circele",
     "PINCODE": 524004,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Raman Bhavan",
     "CENTER_ADDRESS": "Annamaya Circel ",
     "PINCODE": 524004,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Sri Bharathi Boys Days",
     "CENTER_ADDRESS": "Ramalingapuram",
     "PINCODE": 524003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Ujwala Bhavan",
     "CENTER_ADDRESS": "Tippa Raju Vari Street",
     "PINCODE": 524001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Srivani",
     "CENTER_ADDRESS": "Pappula Veedi",
     "PINCODE": 524001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Ganesh Towers",
     "CENTER_ADDRESS": "Dhanalakshmipuram ",
     "PINCODE": 524002,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Saraswathi Dheeraj",
     "CENTER_ADDRESS": "Dhanalakshmipuram ",
     "PINCODE": 524002,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Vidyadara Bhavan",
     "CENTER_ADDRESS": "Perllameta",
     "PINCODE": 523225,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Saraswathi Bhavan",
     "CENTER_ADDRESS": "Mangumur Road",
     "PINCODE": 523001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Vyshnavi ",
     "CENTER_ADDRESS": "Mangumur Road",
     "PINCODE": 523001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Abdul Kalam Bhavan(Vsp)",
     "CENTER_ADDRESS": "Beside Metro Mart, Near Toyoto Show Room, Gurukulam Jr College Road, Marikavalasa, Madhurawada, Visakhapatnam-48",
     "PINCODE": 530048,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Anakapalle",
     "CENTER_ADDRESS": "D.No. 12-12-73, Old Bus Stop Area, Anakaplli.",
     "PINCODE": 531001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Anakapalle",
     "CENTER_ADDRESS": "D.No. 12-12-68, Old Bus Stop Area, Anakaplli.",
     "PINCODE": 531001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Anakapalle",
     "CENTER_ADDRESS": "D.No. 12-12-37, Old Bus Stop Area, Anakaplli.",
     "PINCODE": 531001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Asilmetta Iit Academy",
     "CENTER_ADDRESS": "Door No 48-6-16\/A,Opp.Rama Talkies Main Gate,Sri Nagar",
     "PINCODE": 530016,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Asilmetta Iit Academy",
     "CENTER_ADDRESS": "Door No:9-25-25,Sri Sai Kiran Residency,Near Tempany School C-Gate,Asilmetta",
     "PINCODE": 530017,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Bhageeradha Marikavalasa State",
     "CENTER_ADDRESS": ",D No: 6-28\/1, Bhageeradha Bhavan Mariakavalasa State, Marikavalasa, Madhurawada",
     "PINCODE": 530048,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Indra Towers Pm Palem",
     "CENTER_ADDRESS": "Sri Chaitanya Girls Resicdencial,Near Car Shed Junction,Pm Palem, Madhurawada, Visakhapatnam-530041",
     "PINCODE": 530041,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Kamakshi Complex Palasa",
     "CENTER_ADDRESS": "Old Nh-5 Road, Opp Honda Show Room, Padmanabhapuram, Kasibugga.",
     "PINCODE": 532222,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Raman Bhavan & Sripadha Girls Res",
     "CENTER_ADDRESS": "Kapulupada Road, Boyapalam",
     "PINCODE": 531163,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Raman Bhavan And Sripadha Boys Hostel ",
     "CENTER_ADDRESS": "Raman Bhavan And Sripadha Boys Hostel , Ozone Valley Road,Marikavalasa,Bpcl Bunk Back Side,Opp Gayatri Hospital Visakhapatnam",
     "PINCODE": 530048,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Raman Bhavan Nad",
     "CENTER_ADDRESS": "Raman Bhavan\nD.No 58-22-50\nSusarla Colony\nVisakhapatnam\n",
     "PINCODE": 530027,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Raman Bhavan-1 Vsp",
     "CENTER_ADDRESS": "Door No:47-3-16,Raman Bhavan-1,5Th Lane Dwarakanagar",
     "PINCODE": 530016,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Raman Bhavan-1 Vsp",
     "CENTER_ADDRESS": "Door No:48-6-6\/2,Raman Bhavan Excel Campus,Srinagar Colony",
     "PINCODE": 530016,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Sarada Bhavan Nad",
     "CENTER_ADDRESS": "Sarada Bhavan\nD.No 58-1-357\nSyamala Arcade\nButchirajupalem\nNad Kotharoad\nVisakhapatnam\n",
     "PINCODE": 530027,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Satyam Campus",
     "CENTER_ADDRESS": "Kapulupada Road, Boyapalam",
     "PINCODE": 531163,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Sivam Campus",
     "CENTER_ADDRESS": "Boyapalem,\nKapuluppada Road, \nParadesipalem , \nVisakhapatnam",
     "PINCODE": 531163,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Sowdamini Soudham Gajuwaka",
     "CENTER_ADDRESS": "D No :26-46-1,Chaitanaya Nagar,Old Gajuwaka",
     "PINCODE": 530026,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Sowdamini Soudham Gajuwaka",
     "CENTER_ADDRESS": "D No:26-43-5\/1,Chaitanyanagar,Old Gajuwaka",
     "PINCODE": 530026,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Sowdamini Soudham Gajuwaka",
     "CENTER_ADDRESS": "D No:24-3-1,Vuda Colony,Pedagantyada",
     "PINCODE": 530026,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Sowdamini Soudham Gajuwaka",
     "CENTER_ADDRESS": "D No:6-62-7\/1,Sramika Nagar,Chinagantyada",
     "PINCODE": 530026,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Sri Aurobindo Bhavan",
     "CENTER_ADDRESS": "Kommadi Village  Down Road -Near By Anjali-Geetanjali Towers Back Side Building.",
     "PINCODE": 530048,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Sri Krishna Bhavan Vsp",
     "CENTER_ADDRESS": "Opp.Gayatri Medical  College,O Zone Valley Road,Marikavalsa",
     "PINCODE": 530048,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Sri Sai Bhavan Vsp",
     "CENTER_ADDRESS": "Carshed Junction,Near  More Backsidepilakavani Palem ,P M Palem,Pin-534001",
     "PINCODE": 530041,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Sri Vaibhavi Bhavan Vsp",
     "CENTER_ADDRESS": "Door No 10-27-8\/2,\nWaltair Uplands,\n2Nd Left,3Rd Bulding,\nOpp S3 Boutique, ",
     "PINCODE": 530013,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Srikakulam",
     "CENTER_ADDRESS": "Plot No. 1,3 & 5, Bankers Colony, Behind Deepalmahal",
     "PINCODE": 532001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Srikakulam",
     "CENTER_ADDRESS": "Plot No. 125, Bankers Colony, Behind Deepalmahal",
     "PINCODE": 532001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Srikakulam",
     "CENTER_ADDRESS": "New Colony",
     "PINCODE": 532001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Srikakulam",
     "CENTER_ADDRESS": "Rella Street, Near Rtc Complex",
     "PINCODE": 532001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Swami Vivekananda Bhavan",
     "CENTER_ADDRESS": "Bheemili Cross Road,Bheemili Mandal, Visakhapatnam Dist",
     "PINCODE": 531163,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vaidehi Steel Plant",
     "CENTER_ADDRESS": "Ukkunagaram, Steel Plant Main Road",
     "PINCODE": 530032,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Valmiki Bhavan State",
     "CENTER_ADDRESS": "Near Leela Toyoto Show Room Back Marikavalasa",
     "PINCODE": 530048,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vasavi Bhavan Rajam",
     "CENTER_ADDRESS": "Opp:Hero Show Room, Srikakulam Road,Saradhi Vill, Rajam",
     "PINCODE": 532127,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vignesh Towers Asilmetta Days",
     "CENTER_ADDRESS": "Dno 9-1-250,Asilmetta,Rama Takies Road, Visakhapatnam 530016",
     "PINCODE": 530016,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vignesh Towers Asilmetta Days",
     "CENTER_ADDRESS": "Dno 9-1-257,Asilmetta,Rama Takies Road, Visakhapatnam 530016",
     "PINCODE": 530016,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vignesh Towers Asilmetta Days",
     "CENTER_ADDRESS": "Dno 9-17-52,Asilmetta,Rama Takies Road,Amar Nagar Visakhapatnam 530016",
     "PINCODE": 530016,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Viswamitra Bhavan Vsp",
     "CENTER_ADDRESS": "Viswamithra Bhavan\nD.No 58-28-1\nButchirajupalem\nNad Kotha Road\n",
     "PINCODE": 530027,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vizianagaram",
     "CENTER_ADDRESS": "Plot No-102, 103,110,111, Naidu Colony, Thotapalem, Vizianagaram",
     "PINCODE": 535003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vizianagaram",
     "CENTER_ADDRESS": "Plot No - 14,14, Naidu Colony, Thotapalem, Vizianagaram",
     "PINCODE": 535003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vyas Bhavan Vsp",
     "CENTER_ADDRESS": "Door No: 48-8-13, \nBeside: Budil Park Hotel,\nAssilmetta ,\nDhwaraka Nagar,",
     "PINCODE": 530016,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vyas Bhavan Vsp",
     "CENTER_ADDRESS": "Dr.No.48-8-14\nBeside Budhil Park \nAssilmetta ,\nDwarakanagar,",
     "PINCODE": 530016,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vyas Bhavan Vsp",
     "CENTER_ADDRESS": "D. No 48-8-11\nBeside Budhil Park \nAssilmetta ,\nDwarakanagar.",
     "PINCODE": 530016,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vyas Bhavan Vsp",
     "CENTER_ADDRESS": "Andhra Systems\nDoor No 48-16\/6\nSrinagar\nAsillmetta",
     "PINCODE": 530013,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vyjayanthi Woodland",
     "CENTER_ADDRESS": "D No 48-14-62,Woodland Shop Upstair.Asilmetta, Rama Takies Road ,Vsp 530016",
     "PINCODE": 530016,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Addanki",
     "CENTER": "Anjaneya Sadan Addanki",
     "CENTER_ADDRESS": "D.No.31-419, 31-420, Oil Mill Road, Addanki - 523201.",
     "PINCODE": 523201,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Bapatla",
     "CENTER": "Saraswathi Soudham Bapatla",
     "CENTER_ADDRESS": "D.No.94\/1, Vijayalakshmi Puram, Bapatla - 522101.",
     "PINCODE": 522101,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Bapatla",
     "CENTER": "Veda Vyas Bhavan Bapatla",
     "CENTER_ADDRESS": "D.No.Wb4-94A, Immadisetty Vari Palem, Suryalanka Road, Bapatla - 522101.",
     "PINCODE": 522101,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Chilakaluripet",
     "CENTER": "Cpt Srinivasa Sadan Chilakaluripet",
     "CENTER_ADDRESS": "D.No.24-85\/1 & 24-85\/2, Gandhipet, Chilakaluripet - 522616.",
     "PINCODE": 522616,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Chilakaluripet",
     "CENTER": "Siddhartha Campus Chilakaluripet",
     "CENTER_ADDRESS": "D.No.25-367 & 25-367\/1, Near R.V.S. High School, Chilakaluripet - 522616.",
     "PINCODE": 522616,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Abdul Kalam",
     "CENTER_ADDRESS": "D.No.22-4-105, Hema Sudarshana Complex, Jinnah Tower Centre, Lalapet, Guntur - 522003.",
     "PINCODE": 522003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Amaravathi Guntur",
     "CENTER_ADDRESS": "D.No.7-17-103 & 7-17-104, 4Th Line, Srinagar, Guntur - 522002.",
     "PINCODE": 522002,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Annamaya Bhavan Guntur",
     "CENTER_ADDRESS": "D.No.3-14-43, 1St Line, Pattabhipuram, Opp. Gkr Public School, Guntur - 522006.",
     "PINCODE": 522006,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Bharadwaja Bhavan",
     "CENTER_ADDRESS": "1St Line, Naidupet, Besides Sub-Registrar Office, Guntur - 522007.",
     "PINCODE": 522007,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Chaitanya Lakshmi",
     "CENTER_ADDRESS": "D.No.22-4-47, Titanic Show Room Upstairs, Near Old Bus Stand, Lalapet, Guntur - 522003.",
     "PINCODE": 522003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Rabindranath Tagore Gnt",
     "CENTER_ADDRESS": "D.No.1172\/A, 1173\/B, Anmol Towers, Ponnur Road, Guntur - 522003.",
     "PINCODE": 522003,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Sri Vasavi Bhavan",
     "CENTER_ADDRESS": "D.No.35\/A, Saibaba Road, Guntur - 522007.",
     "PINCODE": 522034,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Sri Venkateswara Palakaluru",
     "CENTER_ADDRESS": "D.No.88\/1, Gorantla, Guntur - 522034.",
     "PINCODE": 522034,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Visharada Bhavan",
     "CENTER_ADDRESS": "D.No.4-18-38\/3, Vidya Nagar, Ring Road, Guntur - 522007.",
     "PINCODE": 522007,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Vivekananda Bhavan",
     "CENTER_ADDRESS": "D.No.4-12-41, 1St Line, Naidupet, Koritepadu, Guntur - 522007.",
     "PINCODE": 522509,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Vyas Bhavan Guntur",
     "CENTER_ADDRESS": "D.No.326\/P, 327\/P, Inner Ring Road, Reddypalem, Guntur - 522509.",
     "PINCODE": 522509,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Vydehi Bhavan Guntur",
     "CENTER_ADDRESS": "D.No.11-207, Amaravathi Road, Gorantla, Guntur - 522034.",
     "PINCODE": 522034,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Icon Campus",
     "CENTER_ADDRESS": "D.No.5-89-9, 3Rd Line, Lakshmipuram, Guntur - 522007.",
     "PINCODE": 522007,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Mahathi Bhavan",
     "CENTER_ADDRESS": "D.No.5, Ts No.1742\/1-2, 4\/2, Navabharat Nagar, Guntur - 522006.",
     "PINCODE": 522006,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tenali",
     "CENTER": "Vyas Bhavan Tenali",
     "CENTER_ADDRESS": "D.No.2-1-74, Gandhi Nagar, Ratna Talkies Centre, Tenali - 522201.",
     "PINCODE": 522201,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Narasaraopet",
     "CENTER": "Narasaraopet Ramanujan Bhavan",
     "CENTER_ADDRESS": "D.No.11-23-1, Ramireddy Pet, Narasaraopet - 522601.",
     "PINCODE": 522601,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Narasaraopet",
     "CENTER": "Nrpt Cv Raman Bhavan",
     "CENTER_ADDRESS": "D.No.12-13-27\/4, 60 Feet Road, Prakash Nagar, Naraaraopet - 522601.",
     "PINCODE": 522601,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Piduguralla",
     "CENTER": "Gautama Buddha Bhavan Piduguralla",
     "CENTER_ADDRESS": "D.No.416\/B, Kotaiah Sastry Bazar, Piduguralla - 522413.",
     "PINCODE": 522413,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Avanthi Bhavan",
     "CENTER_ADDRESS": "D.No.589-11\/5, 1St Line, Chandramouli Nagar, Guntur - 522007.",
     "PINCODE": 522007,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Medical Academy",
     "CENTER_ADDRESS": "D.No.5-91-19 & 5-91-20A, 4Th Line, Lakshmipuram, Guntur - 522007.",
     "PINCODE": 522007,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Repalle",
     "CENTER": "Parameswara Sadan Repalle",
     "CENTER_ADDRESS": "D.No.9-35-210 & 9-35-210\/1, Uppudi Road, Repalle - 522265.",
     "PINCODE": 522265,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tenali",
     "CENTER": "Annamaya Bhavan Tenali",
     "CENTER_ADDRESS": "D.No.21-9-24 , Ramalingeswara Pet, Bhagavathula Vaari Veedhi, Besides Andhra Bank, Tenali - 522201.",
     "PINCODE": 522201,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tenali",
     "CENTER": "Tenali Campus",
     "CENTER_ADDRESS": "D.No.5-23-54, Near Ii-Town Police Station, Jayaprakash Nagar, Tenali - 522201.",
     "PINCODE": 522201,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Anantapur",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No 8-74A, Beside Head Post Office, Near Andhra Bank, Anantapur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Anantapur 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Near Pavan Gas Agency, Rto Office Road, Housing Board, Anantapur 515001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Anantapur 5",
     "CENTER_ADDRESS": "Sri Chaitanya  School ,Opp.Tata Showroom,Kakkalapalli,Rudrampeta By Pass,Ananthapur 515672",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Anantapur 6",
     "CENTER_ADDRESS": "Sri Chaitanya  School \nNear Kamma Bhavan,\nOld Nirmala Nursing College\nLakshmi Srinivasa Nagar\nAnantapur-515004,\n",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Anantapur Cbse",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Old Dps School ,Opposite Tata Showroom,Hyderabad High Way Pamurai Village Anantapur 515001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Anantapur Res",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Sakshi Office,Opp: Tata Motors,Rudrampeta By-Pass,Anantapur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Ananthapur 10",
     "CENTER_ADDRESS": "Sri Chaitanya  School,New Revenue Office Backside,Rudrampeta,Ananthapur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Ananthapur 7",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Survey No.:149\/4,  Ward No.: 13,  Shirdi Nagar,  Near Rtc Bus Stand,Opp. Anand Hospital Anantapur 515001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Ananthapur 8",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No.315-1B,Ward No.28,L.P.No.518\/85, Singarayani Colony,New Revenue Colony, Anantapuramu 515001.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Ananthapur 9",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No 10\/413,Adimurthy Nagar,Opposite Devi Nursing Home,Near Sri Chaitanya Jr College ,Ananthapur 515001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Gorantla",
     "CENTER_ADDRESS": "Sri Chaitanya  School 2\/277  Oppsite Market Yard Kadiri - Hindupur Main Road,Beside Spvm Degree College Gorantla (M&V) Anantapur Dist A.P - 515231",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Guntakal",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No:17\/1111, Rajendra Nagar,Near Venkateswara Swamy Temple, Post Office Line, Guntakal,Ananthapur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Guntakal 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No: 4\/369, Dmm Gate Road,Near Panduranga Swamy Temple,P&T  Colony,Guntakal,Ananthapur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Guntakal 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Oppo. Mahendra Function Hall,Tilak Nagar, Guntakal515801",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Hindupur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door No 12-1-76\/G2, Palani Nagar, Beside Rajadhani Function Hall, Hindupur,Ananthapur - 515201",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Hindupur 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door No 26, Satyanarayana Peta Mf Road, Hindupur, Ananthapur-515201",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Kadiri",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door No : 13\/13\/1\/C ,Madanapalli Road,Oppo.Chowdeswari Temple,Kadiri,Satya Sai Dist 515591",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Kalyanadurg",
     "CENTER_ADDRESS": "Sri Chaitanya  School, D. No:-359\/1A, Opp Govt Hospital Bellary Road, Kalyanadurg, Anantapur (Dt) 515761",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Kothacheruvu",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No : 7\/196, Penugonda Road Kothacheruvu Anantapur 515133",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Anantapur",
     "CENTER": "Tadipatri",
     "CENTER_ADDRESS": "Sri Chaitanya  School,  Nethaji School Compound,\n Behind Rice Mill, \nKalavakatta Street, \nTadipatri, Anantapur  515411 \n\n",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Amaravathi",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Near Museum Road,Amaravathi ,Guntur 522020 ",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Bapatla",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No: 8-3-8, Opp Old Maa Cable, Office, Bhimavaripalem, Bapatla",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Bapatla 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door No -4-10-139\/1Srinivas Nagar Colony,Bapatla",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Chilakaluripet",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Gundabolu Ramachandra Hospital, Subbaiah Thota, Chilakaluripet Guntur 522616",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Chilakaluripet 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Old Drn Scvs Jr.College Building,Nsp Office, Narsaraopet Road, Chilakaluripet,Guntur 522616",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Chirala 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Nalla Paneni Towers, Opp Margadharsi Chit Funds Pvt.Ltd,Munthavaricenter,Chirala 523165",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Dachepalli",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Kranthi Nursing Home,Narayanapuram,Dachepalli(Md)Guntur(Dt)-522414",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Guntur Ds",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Near Nayar Hotel Center, Opp. Centro, Lakshmipuram Main Road, Guntur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Guntur Pri",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Nayar Hotel Center, Lakshmipuram Main Road, Beside Woodland, Guntur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Guntur Res",
     "CENTER_ADDRESS": "Sri Chaitanya  School Mahatma Gandhi 80Feet Inner Ring Road, Reddypalem, Guntur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "International School Whitehouse",
     "CENTER_ADDRESS": "Sri Chaitanya  School Navabharat Nagar, 4Th Lane,Maha Lakshmi Towers\nOpp. Chalapathi Grounds Guntur 522006",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Macherla",
     "CENTER_ADDRESS": "Sri Chaitanya  School 13Th Ward, R&B Bunglow Back Side, Near Palamara ,Macherla Guntur (D.T) 522426",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Nagaralu",
     "CENTER_ADDRESS": "Sri Chaitanya  School ,Telecome Nagar 2Nd Line,Amaravathi Road, Near Tagore Rice Mill,Nagaralu",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Narsaraopet",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door No:11-14-1\/1,Ramireddypet,Bank Colony,Narasaraopet,Guntur.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Narsaraopet 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kota Center  ,Sattenapalli Road, Opp Mahalakshmamma Chettu,Narsaraopet",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Narsaraopet 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School 60 Feet Road , Prakash Nagar Narasaopet,Guntur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Navabharat Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Opp, Reviera Suits Vasantha Lakshmi Appartments,4\/2 Navabharat Nagar,Guntur 522006",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Nehru Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School Buchaithota 1St Line,Opp Vijayawada Railway Track, Nehru Nagar,Guntur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Piduguralla",
     "CENTER_ADDRESS": "Sri Chaitanya  School 7-703\/A Abbubakar Museed Street Opp Axis Bank Piduguralla,Guntur - 522413",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Ponnur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Gbc Road, Ponnur,Guntur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Reddypalem Ds",
     "CENTER_ADDRESS": "Sri Chaitanya  School Inner Ring Road Redyypalem ,Guntur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Sattenapalli",
     "CENTER_ADDRESS": "Sri Chaitanya  School China Majid Center,Sbi Road,Sattenapalli,Guntur 522403",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Sattenapalli 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No 5-8-8, Nagarjuna Nagar,Sattenapalli,Guntur 522403",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Sattenapalli 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School  Park Road,Sattenapalli,Guntur 522403",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Syamala Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School Surveyamala Nagar, Zero Line,Near Army Canteen,Guntur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Tenali",
     "CENTER_ADDRESS": "Sri Chaitanya  School Ganganamma Pet, Tenali",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Tenali 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door-No-21-1-60\/1, Devi Chowk, Ramalingeswarapet,Tenali,Guntur-522201",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Tenali 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Umesh Chandra Statue,Chenchupet,Tenali,Guntur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Tenali-2",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Opp: Government Veterinery Hospital ,Burripalem Road,Tenali 522201",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Guntur",
     "CENTER": "Vinukonda",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside Current Office, Karampudi Road, Vinukonda Guntur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Porumamilla",
     "CENTER_ADDRESS": "Sri Chaitanya  School Desai Mahal Back Side,Near Apsrtc Busstand,Porumamilla(V)Kadapa(Dt)Ap-516193",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Proddutur",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Near Aravinda Ashramam,   Ymr Colony , Proddutur, Y.S.R Kadapa(Dist) 516360",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Proddutur 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Yerraguntla By Pass Road, Near Cine Hub,Proddatur,Kadapa 516360",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Proddutur 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Backside Honda Showroom,Kvr Colony,Mydukur Road,Proddutur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Proddutur 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School Bollavaram Near Golden Park Jammalamadugu Bypass Road Proddatur, Kadapa",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Badwel",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Gandla Street,Porumamilla Road,Badwel,Kadapa 516227",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Kadapa",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Keerthi Park View,Opp Rajiv Park,Maruthi Nagar,Kadapa 516001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Kadapa 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Ambha Bhavani Temple,Near Builtup, Kadapa.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Kadapa 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Nehru Park,Co-Oprative Colony,Kadapa",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Kadapa 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School Arp Colony, Prakash Nagar , Kadapa",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Kadapa 5",
     "CENTER_ADDRESS": "Sri Chaitanya  School 101\/257-2 Rims Bypass Road Kadapa",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Kadapa 6",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Bugga Vanka Project Road,Near Swamy Nagar,Kadapa",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Kadapa 7",
     "CENTER_ADDRESS": "Sri Chaitanya  School #97\/217-8,Near Rto Office,Ysr Circle,C.K.Dinne,Kadapa",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Kadapa 8",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp:Chinnachowk Police Station,Nehrunagar,Kadapa 516002",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Kadapa 9",
     "CENTER_ADDRESS": "Sri Chaitanya  School Rayachoti Ring Road,Vutkur Circle,Kadapa 516003",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Pulivendula",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot 70, Beside Rto Office, Muddanuru Road ,Pulivendula,Kadapa 516390",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Rajampet",
     "CENTER_ADDRESS": "Sri Chaitanya  School Bhuvanagiri Palli,Rajampet,Kadapa 516115",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Rajampet 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School R.S.Road, Rajampet, Kadapa",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Rayachoti",
     "CENTER_ADDRESS": "Sri Chaitanya  School Ngo Colony,Kothapeta,Rayachoti,Kadapa 516269",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Rayachoti 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School 430 Beside Preetham Residency,Rayachoti,Kadapa",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Rayachoti 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School  # 5\/283,Near By Icds Office, Beside Vinayaka Temple, Sundepalli Road, Rajula Colony Rayachoti 516269 ",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kadapa",
     "CENTER": "Rayachoti 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School Krishna Reddy Nagar,Madanapalli Road Rayachoti,Kadapa",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Kakinada 1",
     "CENTER_ADDRESS": "Sri Chaitanya  School #3-16B-4, Old Rto Office Road, Near Mother Teresa Statue,Santhi Nagar, Kakinada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Kakinada 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School\nOpposite Bmc Church\nSanthi Nagar\nKakinada - 533003",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Kakinada 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No.9-16,Srinivasa Colony, Ramanayyapeta, Kakinada Rural-533005, East Godavari District, Andhra Pradesh",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Kakinada 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No1-1111, Jana Chaitanya Layout Near Jewel Medows,Sarpavaram,Kakinada Rural 533005",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Kakinada 6",
     "CENTER_ADDRESS": "Sri Chaitanya  School 10-5-43\/1,Nageswararao Street,Ramarao Peta,Kakinada-533003.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Payakaraopeta",
     "CENTER_ADDRESS": "Sri Chaitanya  School Y Junction,Near Govt Hospital,Payakaraopeta,Kakinada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Sunkarapalem",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Ysr Statueu,Kv Nagar, Yanam, 533464",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kakinada",
     "CENTER": "Yanam",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Ysr Statue, Draksharama Road, Via Yanam, Sunkarapalem 533464",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Adoni",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Chekuri Gardens, Near New Rtc Bus Stand,Adoni,Kurnool 518301",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Adoni 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School 21\/515\/9\/Bcd\/1,Ambedkar Nagar,Revenue Ward-21,A.P.B.H Colony,Adoni,518301",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Allagadda",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Viswarupa Nagar, Allagadda,Kurnool(Dist) 518543",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Alur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Lic Back Side,Alur,Kurnool 521329",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Atmakur",
     "CENTER_ADDRESS": "Sri Chaitanya  School  Near Venkateswara Swami Temple,Gareeb Nagar,Atmakur,Kurnool",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Banaganapalle",
     "CENTER_ADDRESS": "Sri Chaitanya  School Banaganapalli Near Rtc Bus Stop ,Kurnool",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Bethamcherla",
     "CENTER_ADDRESS": "Sri Chaitanya  School 12Th Ward,Dhone Road, Bethamcherla,Kurnool",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Dhone",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Venkatanaini Palli Road,Opp Iti College,Dhone,Kurnool 518222",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool 1",
     "CENTER_ADDRESS": "Sri Chaitanya  School , D.No:451 42\/13B-7 ,Kappala Nagar,Road No 4,Venkata Ramana Colony Lane,Kurnool 518003",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool 10",
     "CENTER_ADDRESS": "Sri Chaitanya  School Venkatadri Nagar, Nera Railway Gate, Kalluru, Kurnool 518002",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School,D.No:40-321-1-F ,Beside Old Ayyappa Swamy Temple,  Bhaskar Nagar,Kurnool 518003",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Beside Old Ravi Theater, Central Plaza, Near Vinayak Ghat, Kurnool",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside Vijaya Durga Degree College, Srinaga Colony,Kurnool",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool 5",
     "CENTER_ADDRESS": "Sri Chaitanya  School Knl652,Sri Chaitanyaschool, Sankhalbagh,Kurnool-518001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool 6",
     "CENTER_ADDRESS": "Sri Chaitanya  School Hno:46-156-D-1A,Budhawarapet Near Padma Chandra(Omni) Hospital, Kurnool",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool 7",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Viswak Garden, Somisetty Function Hall,Sankal Bagh,Kurnool 518001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool 8",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No:6-68\/A,Sc-Colony, Thandrapadu Lake,Opp.Sivalayam,Nandyal Road,Kurnool518007",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool 9",
     "CENTER_ADDRESS": "Sri Chaitanya  School Sri Rama Nagar ,Kurnool",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Kurnool Cbse",
     "CENTER_ADDRESS": "Sri Chaitanya  School \nCrr Secondary School\nDinnedevarapadu Kurnool\nPost Box No :-8 Ananthapur Road",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Nandikotkur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Maddhur Nagar, Beside Sri Rama Theater, Nandikotkur 518401",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Nandyal",
     "CENTER_ADDRESS": "Sri Chaitanya  School 25426-E Behind Muncipal Office Nandyal,Kurnool",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Nandyal 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Srnivasa Nagar,Ttd Road,Opp: Raithubazar,Nandyal,Kurnool 518502",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Nandyal 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School  Ngo'S Colony, Nandyal,Kurnool",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Nandyal 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside Sowjanya Motors,R.S Road,Nandyal,Kurnool(Dist),A.P",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Nandyal 5",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No : 13\/71, Ramakrishna Nagar,Koilakuntla Road, Kanala,Nandyal. Kurnool (Dt)518493",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Pattikonda",
     "CENTER_ADDRESS": "Sri Chaitanya  School 17\/177\/12\/1\nYashoda Garden School\nYashoda Garden\nNear Rtc Bus Stand\nPattikonda\nKurnool\n518380",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Kurnool",
     "CENTER": "Yemmiganur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Geetha Nagar, Yemmiganur, Kurnool(Di),Ap",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Atmakur Nellore",
     "CENTER_ADDRESS": "Sri Chaitanya  School Tenkaya Thopu,Near Raviteja Kalyanamandapam ,Atmakur Nellore",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Buchireddypalem",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp Old Rtc Bus Stand,Buchireddypalem,Nellore",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Gupta Park",
     "CENTER_ADDRESS": "Sri Chaitanya  School 12-4-294,Beside Model High School,Near Gupthapark,Nellore",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Kavali",
     "CENTER_ADDRESS": "Sri Chaitanya  School Pullareddynagar, Behind Rsr Kalyana Mandapam, Kavali,Spsr Nellore Dt 524201",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Kavali 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kalikivari Street , Old Town , Kavali",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Kavali 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Santhinagar Kavali,Spsr Nellore Dt, 524201",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Kovur",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Beside Panchayt Office, Kottur Rama Mandiram Road, Mandabayalu Center, Kovur,Spsr Nellore (D.T) 524137",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Nawabpeta",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp:Sivalayam, Narukur Main Road, Nawabpeta, Nellore",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Nellore",
     "CENTER_ADDRESS": "Sri Chaitanya  School Iskon City,Kondayapalem,Back Side Bharath Pertrol Pump, Vanamthopu, Nellore 524004",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Nellore 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Settygunta Road,Lakshmi Puram,Vengamamba Centre,Nawabpeta,Nellore",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Santhapeta",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kamakshinagar Santhapet , Nellore",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Vinjamuru",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside Praja Vaidhyasala, Near Rtc Bus Stand , Vinjamuru,Nellore",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Ac Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School,  Near Addala Sai Baba Temple,Pulimi Pedda Buchi Reddy Nagar,  Ac Nagar, Nellore 524002",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Balaji Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School Ramji Nagar, 5Th Line , Balaji Nagar Nellore",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Gudur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Sanath Nagar,Opp Z.P Girls High Scool,Gudur,Nellore 524101",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Kota",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Srinivasa Nagar,Kota (Mandal),Nellore (Dt) 524411",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Muthukur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Oppo Post Office,Muthukur ,Nellore",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Naidupet",
     "CENTER_ADDRESS": "Sri Chaitanya  School Agraharpeta, Near Sai Baba Temple, Naidupet, Spsr Nellore Dist 524126",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Nellore Res",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Opp Hdfc Bank Atm, Dhanalakshmipuram,  Nellore524003",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Podalakur",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Chaitanya Nagar,Rapur Road,Podalakur (Mandal),Nellore (Dt) 524345",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Sullurpet",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Rr Super Market ,Gnt Road , Sullurpet,Nellore",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Vedayapalem",
     "CENTER_ADDRESS": "Sri Chaitanya  School Gandhi Nagar ,Vedayapalem",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Venkatagiri",
     "CENTER_ADDRESS": "Sri Chaitanya  School Ammavaripeta, Municipal Office Road, Venkatagiri,Spsr Nellore Dist 524132",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Nellore",
     "CENTER": "Venkatagiri 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Dvs Complex, Raja Street, Venkatagiri, Spsr Nellore (Dt)524132",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Addanki",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Bunglow Road,Addanki,Prakasam -523201",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Chimakurthy",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Gandhi Nagar 7Th Line,Chimakurthy Ongole 523226",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Cumbum",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp.Indian Petrol Bunk,Near Sbi Bank ,Giddalur Road,Cumbum,Ongole",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Darsi",
     "CENTER_ADDRESS": "Sri Chaitanya  School Teacherscolony,Podili(Road),Darsi,Prakasam",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Kandukur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kota Reddy Nager,Kandukur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Kanigiri",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp.Jr College,Kandukur Road,Kanigiri",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Kanigiri 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Subhash Road,Kotha Pet,Kanigiri,Ongole",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Markapuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No.8\/A-20 ,Bodapadu Rod ,Oppisite Rtc Depo,Markapuram,Ongole",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Martur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp. Vijayalakshmi Kalayana Madapam,  Nh-5 Road , Martur,Ongole",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Ongole 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Bhagya Nagar 2Nd Line, Beside Register Office ,Ongole-523001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Ongole 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Opp.Hp Gas Agency,Near Marri Chettu,Mangamur Donka Road,Ongole 523001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Ongole 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School V.I.P. Road,Mangamur Donka,Above Hdfc Bank,Ongole",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Ongole Ds",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside Mahalakshmi Towers, 4Th Line ,Lawyerpet,Ongole-523001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Pamuru",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp.Hp Petrol Bunk ,Nellore Road,Pamuru,Ongole",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Ongole",
     "CENTER": "Singarayakonda",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside I.T.I College,Mulaguntapadu(V),Singarayakonda(M) Prakasam District 523101",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Amalapuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside Msn Complex, Main Road, Amalapuram, East Godavari Dist, 533201",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Amalapuram 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No :I 1-72 ,Backside Of Vl Heights,Abbireddy Canal Bridge,Konkapalli,Amalapuram,Rajahmundry",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Anaparthi",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No 13-37, Canal Road,Ayyappa Temple ,Kothuru Turning,Anaparthi,Anaparthi (Md), Rajahmundry",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Bhimadole",
     "CENTER_ADDRESS": "Sri Chaitanya  School,D.No:10-116,Opp. Fire Station,Eluru, Rajahmundry Road,Bhimadole,West Godavari 534425",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Bhimavaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Plot No:6-126,Sri Rama Kusuma Plaza,Near Nataraj Theater,Chinnamiram,Jp Road, Palakoderu (M), W.G(Dt)534210",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Bhimavaram-2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside Duplex Colony Chinnamiram,Bhimavaram,Rajahmundry 534204",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Chintalapudi",
     "CENTER_ADDRESS": "Sri Chaitanya  School Above Union Bank,Srinidi Complex,Eluru Road,Chintalapudi,Rajahmundry 534460",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Devarapalli",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Opp:Vegetable Market, Eluru Road, Devarapalli Rajahmundry 534313",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Eluru",
     "CENTER_ADDRESS": "Sri Chaitanya  School Chalapathi Towers,4Th Line ,Santhi Nagar ,Eluru,Pin Code:534007",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Eluru Cbse",
     "CENTER_ADDRESS": "Sri Chaitanya  School Parvatha Vardhini Complex  , Near Mahathma Gandhi Statue, Vidyanagar , Eluru. W.G.(Dt) 534003",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Eluru-2",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No 7-179\/2,Near Ganganamma Temple,Balaji Nagar, Chataparru Road, Eluru-534001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Ganapavaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Nidamarru Mandel,Bhavipalem Post, Ganapavaram,Rajahmundry 534198",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Hanuman Junction",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kepinidi Towers, Nuzvid Road,Near Flyover, Hanumanjunction West Godavari 521105",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Jaggampeta",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Krishnaveni Theator , Balaji Center , Jaggampeta, East Godavari 533435",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Jangareddygudem",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No :16-1-120, Beside M.R.Ooffice,Mandavalli Estate, Aswaraopeta Road, Jangareddygudem",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Kaikalur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp: Fci Godowns, Beside Reliance Petrol, Atapaka, Kaikalur-521333",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Kovvur",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Opp Pmmm Govt High School,Beside Yuvraj Function Hall, Nandamuru Road, Kovvur, West Godavari 534350",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Mandapeta 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Main Road ,Near Hp Bunk ,Tapeswaram,Mandapeta,Rajahmundry",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Nagaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Old Havens Campus, Main Road, Nagaram 533247",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Narsapur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Karthikeya Nagar,21St Ward,Peechupalem Road,Narsapuram ,West Godavari (Dt),A.P 534275",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Palakol",
     "CENTER_ADDRESS": "Sri Chaitanya  School  Brodipet 2Nd Street, Bypass Road, Rajugari Building, Palakol, W.G.Dt 534260",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Palakol 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Axis Bank ,Opp.Ambedkar Statue Poolapalli , Palakol , West Gdhavari Dist",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Penugonda",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door No:31-112, Opposite Palace Theater, Siddhantham Road, Penugonda, Ap 534320",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Pitapuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Pada Gaya Temple, Bypass Road, Pithapuram,Rajajmundry",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Rajahmundry 1",
     "CENTER_ADDRESS": "Sri Chaitanya  School H. No : 89-17 21\/1,Morampudi Road, Morampudi - Kesavaram Road, Sri Sai Chaitanya Nagar, Rajahmundry, Andhra Pradesh 533107",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Rajahmundry 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No11-11-1,Opposite Fire Station,Aryapuram,Rajahmundry,East Godavari (Dt) 533103",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Rajahmundry 5",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No-74-6-54, Near T T D Kalyana Mandapam,Opp Swatantra Kumar Church,Prakesh Nagar,Rajahmundry",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Rajahmundry 6",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No:17-12\/8\/1,Krishna Nagar,Seetam Peta,Near Satyam Gari Rice Shop,Rajahmundry,East Godavari (Dt)533104",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Rajahmundry 7",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No:4-699\/1, Beside Beejapuri Township, Srirampuram Road, Diwancheruvu, Rajanagaram Mandam, East Godavari, Andhrapradesh - 533296",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Rajole",
     "CENTER_ADDRESS": "Sri Chaitanya  School(Ps) Em School,Opp. Annapurna Theater, Mogalikuduru,Rajole,Rajahumundry 533249",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Ramachandrapuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No:5-282\/1,Sri Chaitanya  School-Ramachandrapuram, Srinagar, Opposite Vsm Engineering College Ramachandrapuram,Pasalapudi Branch, Andhrapradesh - 533255",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Ravulapalem",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Ankalamma Temple,Ubalanka Road,Ravulapalem ,East Godavari Dist 533238",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Sakhinetipalli",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Antarvedi Palem, Beside Indian Oil Petrol Bunk,Sakhinetipalli Mandal,E G Dist-533252",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Tadepalligudem",
     "CENTER_ADDRESS": "Sri Chaitanya  School Oppo.Cwc Gudem,Nallagerla Road,Tadepalligudem 534101",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Tadepalligudem Cbse",
     "CENTER_ADDRESS": "Sri Chaitanya Olympiad School,Vasavi Ideal Public School Building,Chinnatadepalli,Kadiyadda Post,Tadepalligudem 534101",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Tanuku",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Ikea Nagar,Nh-16,Tanuku,Wg.Dist,534211",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Tanuku 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Petrol Bunk,Vishnu Priyanagar ,Tanuku Velpuru 534222",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "The Park International School",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No:89-17-1\/21 Chaitanya Nagar, Morampudi Road ,Rajahmundry",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Tuni 1",
     "CENTER_ADDRESS": "Sri Chaitanya  School Durgadas Street,Opposite Suresh Kumar Hospital, Kotha Peta, Tuni, Rajahmundry",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Tuni 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No:3-41-8\/4, Sai Nagar, Mr Peta,Tuni,Rajahmundry",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Rajahmundry",
     "CENTER": "Yeleswaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door No: 3-377\/1, Near Rajula Babu Temple, Lingampathy Road,Yeleswaram ,Rajahmundry,Ap",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Air By-Pass",
     "CENTER_ADDRESS": "Sri Chaitanya  School Jaya Lakshmi Colony, Stv Nagar, Air By Pass Road, Near Passport Office, Tirupati",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Madanapalli",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Mallikarjuna Circle, College Road, Madanapalli,Chittoor 517325 ",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Madanapalli 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Dr.No. Iii-145-6-12-4, Prasanth Nagar, Beside. Sri Siddhartha Jr. College,  Madanapalli,Tirupathi - 517325",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Piler",
     "CENTER_ADDRESS": "Sri Chaitanya  School 3-421, Lakshmi Puram,Piler, Chittoor (Dist),Tirupathi 517214.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Punganur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Mpdo Office,    R.R Kalyana Mandapam,Mbt Road,Punganur-517247",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Puttur",
     "CENTER_ADDRESS": "Sri Chaitanya  School #12\/64\/1A,Swamy Street,Puttur,517583",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Puttur 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Parameswara Mangalam,K.Palem,Puttur ,Tirupathi",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Puttur 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kalyanapuram,Opp.Fire Station, Swami Street Kn Road,Puttur 517583",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Srikalahasti",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No-1-1988,Jayram Rao Street,Srikalahasti,Tirupathi",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Srikalahasti 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School 16\/550\/3,Sri Ram Nagar Colony,Panagal Road,Opp: Sbi (Adb) Branch,Srikalahasti. Ap 517640",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Srikalahasti 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Sri Lakshmi Kamakshi Kalyana Mandapam, Opp Darmaraj Temple,Srikalahasti,Tirupathi",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Tarakarama Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Opp:A.G.Staff Quarters,Tarakaramanagar,Perur,Tirupati(Rural)571505",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Bangarupalyam",
     "CENTER_ADDRESS": "Sri Chaitanya  School Thagguvaripalli, Bangarupalyam,Tirupathi",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Chandragiri",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Vijay Nagar Colony,Canara Bank Road,Chandragiri 517101",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Chittoor",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp.Thapovanam School,Teachers Colony,Greamspet,Vellore Road,Chittoor",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Chittoor 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School #27-515\/B,Telephone Colony Road,Ramnagar Colony,Chittoor",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Chittoor 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School 28-1428, Ram Nagar Colony,Chittor ,Tirupathi",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Gs Mada",
     "CENTER_ADDRESS": "Sri Chaitanya  School 15-2-126\/A2 , Beside Lakshmi Narayana Swamy Temple Gsmada Street Tirupati",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Koralagunta",
     "CENTER_ADDRESS": "Sri Chaitanya  School 20-2--478\/A2,Maruthinagar,Korlagunta,Tirupati-517501",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Mr Palli",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot:26 New Maruthi Nagar, Air By Pass Road,Mr Palli,Tirupathi",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Murugani Palli",
     "CENTER_ADDRESS": "Sri Chaitanya  School,D.No.22-978\/Bb, Kameshwar Nagar, Muruganipalli, Chittoor,Tirupathi",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Palamaneru",
     "CENTER_ADDRESS": "Sri Chaitanya  School Gudiyatham Road,Sri Nagar Colony,Near Ysrcp Party Office,Palamaneru,Tirupathi 517408",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Renigunta",
     "CENTER_ADDRESS": "Sri Chaitanya  School Vinayaka Nagar, Renigunta, Tirupathi",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Srinivasapuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Telecom Colony, Srinivasapuram, Tirupati",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Tirumala By Pass",
     "CENTER_ADDRESS": "Sri Chaitanya  School No:18-1-7\/10, Beside Pai Vicroy Hotel, Rama Chandra Nagar, Tirumala By Pass,Tirupathi",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Tirupathi Girls Res",
     "CENTER_ADDRESS": "Sri Chaitanya  School #10-128\/6-9     Nethaji Nagar P G N Tower  Tiruchanur   Tirupati  Pin:517507",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Tirupathi Ipl",
     "CENTER_ADDRESS": "Sri Chaitanya  School Ipl Branch,Bairagipatteda, Near Rims,Tirupathi 517501",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Tsn Puram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Dr. No. 20-3-131\/1A, Siva Jyothi Nagar, Sathyanarayanapuram, Opposite Srivari Sannidhi, Back Side Street Sbi Executive Guest House, Tirupathi, Chittoor District, Ap 517501",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "V Kota",
     "CENTER_ADDRESS": "Sri Chaitanya  School Chowdepalle Road, Vkota,Tirupathi 517424",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Tirupathi",
     "CENTER": "Vikas Campus",
     "CENTER_ADDRESS": "Sri Chaitanya  School Tana Pally Road,  Thiruchnor, Thirupathi ",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Ashoknagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No:74-14-2, Old Check Post Center, Yanamalakuduru Lakula Road, Krishna Nagar (Ashok Nagar), Beside Commercial Tax Office, Vijayawada-520007.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Avanigadda",
     "CENTER_ADDRESS": "Sri Chaitanya  School 5Th Ward, Near Santha Market Avanigadda,Vijyawada Krishna (Dt)",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Bhaskar Bhavan Ipl",
     "CENTER_ADDRESS": "Sri Chaitanya  School C\/O Raman Bhavan -3,Nidamanuru,Vijaywada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Bhavanipuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Dno:76-8\/6-5\/1,Gudivada Rama Rao Street,Swathi Theatre Road,Bhavanipuram,Vijayawada-520012",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Challapalli",
     "CENTER_ADDRESS": "Sri Chaitanya  School Club Road, Ramanagaram(Village),Challapalli(Mandal), Krishna (Dist),521126.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Currency Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School 2Nd Line, Om Namashivya Street, Currency Nagar,Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Gannavaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Gnt Road ,Kothapeta,Gannavaram,Vijayawada 521101",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Gosala",
     "CENTER_ADDRESS": "Sri Chaitanya  School Punadipadu Village,Kankipadu Mandal,Gosala,Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Gudivada",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No:10\/153, Rajendra Nagar 1St Line, Gudivada,Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Ibrahimpatnam",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near State Bank Of India,Opp-Mandalam Office ,V.T.P.S Road,Ibrahimpatnam,Krishna (Dt)521456",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "International School",
     "CENTER_ADDRESS": "Sri Chaitanya  School Gayathri Nagar,Polyclinic Road,Near Benz Circle,Vijayawada 520008",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Intl Bezawada",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No:57-6-21\/2, Abc  Building, Old Post Office Road, Beside Sonovision, Padamata, Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Jaggaiahpet",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp: Yogirama Hospital, Uma Gopal Complex,Jaggaiahpet,Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Kanchikacherla",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp.Pratap Tvs Show Room,Kanchikacherla,Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Kankipadu Ds",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside Tvs Show Room,Bandar Road,Kankipadu,Vijayawada 521151",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Krishna Lanka",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No:-41-1\/8-42,Gowthami Nagar 3'Rd Line Opposite American Hospital,Krishna Lanka,Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Machilipatnam",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No : 21\/478, Sri Chaitanya  School, Sai Baba Temple Road, Bhaskarapuram , Machilipatnam , Krishna(Dist), Ap 521001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Mangalagiri",
     "CENTER_ADDRESS": "Sri Chaitanya  School, D. No 1-816, Near Head Post Office, Mangalagiri Vijayawada 522 503",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Mangalagiri 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School,D.No 5-470,Ward No.5,Tenali Road,Near Markandeya Kalyana Mandapam,Above Icici Bank,Mangalagiri 522 503",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Mangalagiri 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door No: 14-271\/1, Chaiatanya Thopavanam Ashramam, Krishna Nagar, Tadepalli ,Mangalagiri - 522501",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Mangalagiri-5",
     "CENTER_ADDRESS": "Sri Chaitanya  School Sharoff Bazar, Vadlapudi Center,Mangalagiri,Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Marutinagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No:32-26-110\/124, Sri Bhavani Mansion,Marutinagar,Eluru Road,Vijayawada 520004",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Mogulrajapuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No36-12\/15\/2A,Ramarao Street,Madhu Garden,Mogulrajapuram,Vijayawada 520010",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Mylavaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Dno:-2-58,Beside Narayana Theater , Mylavaram Mylavaram(M.D)Krishna (D.T)-521230 ",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Nandigama",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp Varun Bajaj , Raithupeta,Nandigama,Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Nunna",
     "CENTER_ADDRESS": "Sri Chaitanya  School 6-80, Beside Bsnl Telephone Exchange, Main Road, Nunna,Vijayawada - 521212",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Nuzvidu",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Cherukuri Complex, Behind Hero Honda Show Room, H.Junction Road, Nuzvidu, Krishna (Dt) 521201",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "One Town",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No:4-1-27, Bangaraiah Kottu Center,One Town,Vijayawada Krishna (Dt) 520009",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Patamata Lanka",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No:40-12-3\/5,    Opp:Aswini Enclave,Seetharama Nagar, Patamatalanka,Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Penuganchiprolu",
     "CENTER_ADDRESS": "Sri Chaitanya  School 1-1,Makkapet Road,Penuganchiprolu,Krishna-521191.Ap",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Poranki",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No-15-113,Prabhu Nagar,Poranki,Vijayawada,Krishna 521137.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Repalle",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Rajya Laksmi Theatre,Old State Bank Compound,Repalle 522265",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "S.N. Puram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Dr No : 24-25-63,Near Food Junction,Opp.Railway Quarters,Brts Road,Durgapuram,Satyanarayanapuram,Vijayawada",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Sing Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No. 43-78-7 Krishna Hotel Center, Ajit Sing Nagar, Vijayawada-520015",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Tiruvuru",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp Nagarjuna College,  Bosu Bomma Centere, Tiruvuru Vijayawada 521235",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Vijayawada Ipl",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No:2-207, Amaravathi Colony, Road No 1, Kanuru, Vijayawada 520007",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Visannapet",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Kukkadapu Prasad Compex, Beside Surveyndicate Bank, Main Road, Visannapeta 521215 ",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Vijayawada",
     "CENTER": "Vuyyur",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No :- 8-269, Sri Chaitanya  School, Anu Arcade Building, Behind Care Hospital, Katuru Road, Vuyyuru, Krishna (D.T) 521165",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Anakapalli",
     "CENTER_ADDRESS": "Sri Chaitanya  School 80 Feet Ring Road , Opp Hema Sekhar Degree College,  Station Road,  Anakapalli,Visakhapatnam -531001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Asilmetta",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No 10-12-8, Opp Pydah Degree College Rednam Gardens Ram Nagar,Asilmetta Visakhapatnam -530002",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Asilmetta 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School 11-4-1\/1,Uday Sri Towers, Ramnagar,Asilmetta,Visakhapatnam",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Bobbili",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Cbm Church , Balijipeta Road, Bobbili,Visakhapatnam",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Dwarakanagar Ipl",
     "CENTER_ADDRESS": "Sri Chaitanya  School 47-7-114,Dwarakanagar 6Th Lane,Opp.Sankaramatam,Visakhapatnam. 530016",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Gajuwaka",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No:26- 42-10\/2,Beside Sri Chaitanya Junior Kalasala,Chaitanyanagar,Old Gajuwaka,Visakhapatnam-530026.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Gajuwaka 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School 27-1-65,Srinagar,Gajuwaka,Visakhapatnam,530026",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Kommadi",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Vijaya Mohan Layouts,Near Chaitanya Engg College, Kommadi Village,Chinagadili Md Madhurawada Visakhapatnam 530048",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Kurmannapalem",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door No: 31\/6-3\/1                             Opp. Steel City Apsrtc Bus Depo Sathavahananagar Road No.6,Mainroad Kurmannapalem, Gajuwaka Mandal  Visakhapatnam 530046",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Madhurawada",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp: Cmr Gardens, Madhurawada , Visakhapatnam 530048",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Madhurawada 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Near Fly Over Bakkanapalem Road, Madhurawada Visakhapatnam 530048",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Mvp Colony",
     "CENTER_ADDRESS": "Sri Chaitanya  School 1-10-2\/4, Usha Residency, Sector-1,Mvp Colony, Visakhapatnam",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Nad",
     "CENTER_ADDRESS": "Sri Chaitanya  School, D.No. 58-1-237, Teegala Towers, Marripalem Road, Nad, Vizag 530009",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Nad 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School, D-No-58-15-116\/A,  Opp Gajanana Fort, Santhi Nagar, Nad ,Visakhapatnam 530009",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Narsipatnam",
     "CENTER_ADDRESS": "Sri Chaitanya  School 2-101\/1, Near Rtc Complex , Anakapalli Road, Narsipatnam-531116 Visakhapatnam Dist.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Palasa",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No:14-1-279\/A,Near Ayyappa Swamy Temple,Old Nh-5 Road,Padmanabhapuram,Palasa-Kasibugga,Srikakulam Dist 532222",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Parvathipuram",
     "CENTER_ADDRESS": "Sri Chaitanaya  School , Opp- Sri Venkateswara Nurshing Home ,Sundernarayanapuram Colony , Belagum ,Parvathipuram , Vizianagaram ( Dist ) .",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Pendurty",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Sbi, Pulaganipalem Road, Pendurty",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Rajam",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp Electrical Sub Station, Ponduru Road, Rajam, Srikakulam (Dist) 532127",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Srikakulam",
     "CENTER_ADDRESS": "Sri Chaitanya  School Mahalakshmi Nagar , Near Deo Office,Womens College Road,Srikakulam",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Srikakulam 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Tangi Suryanarayana Colony, Near Ayyappa Swamy Temple, Adivarampeta, Chapuram Panchayat, Palakonda Road, Srikakulam 532 001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vizianagaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School, 100 Feet Ring Road, Dharmapur, Near Venkateswara Swamy Temple, Vizianagaram 535001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Vizianagaram 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kamakshinagar Near Bus Stop,Bowdara Main Road, Vizianagaram",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Andhra Pradesh",
     "CITY": "Visakhapatnam",
     "CENTER": "Yalamanchili",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Fire Station,Ramakrishnapuram, Yelamanchili,Visakhapatnam-531055",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Bihar",
     "CITY": "Patna",
     "CENTER": "Knowledge Hub",
     "CENTER_ADDRESS": "Abc tower, Main Boring road, Plot no - 134, Opp Harihar Chamber, Patna, 800001",
     "PINCODE": 800001,
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Delhi",
     "CITY": "Delhi",
     "CENTER": "Gurugram 1",
     "CENTER_ADDRESS": "Sri Chaitanya  School Sushant Lok, C Block, Gurugram",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Delhi",
     "CITY": "Delhi",
     "CENTER": "Gurugram 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Sector 56, Block-C , Sushant Lok Phase-Ii , Village-Ghatta Tehsil-Sohna Near Huda Market, Gurugram, Haryana 122002",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Delhi",
     "CITY": "Delhi",
     "CENTER": "Gurugram 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School Block K#6, Sector 83, Behind Vatika Life Style Homes, Gurugram, Haryana 122001",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Haryana",
     "CITY": "Meham",
     "CENTER": "Meham",
     "CENTER_ADDRESS": "Sri Chaitanya  School 108Th Milestone,Nh-10,Hisar Road,Meham,Haryana-124112",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Haryana",
     "CITY": "Palwal",
     "CENTER": "Palwal 1",
     "CENTER_ADDRESS": "Sri Chaitanya  School Aligarh,Palwal Road,Near Kithwari Village,Haryana-121102",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Haryana",
     "CITY": "Rewari",
     "CENTER": "Rewari",
     "CENTER_ADDRESS": "Sri Chaitanya  School E-Block,Suncity,Sector 6-7,Rewari,Haryana-123401",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Banaswadi",
     "CENTER_ADDRESS": "Sri Chaitanya  School 84\/1, Garden House, 5Th Main, Ombr Layout, Banaswadi, bengaluru-560033",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Bannerghatta Road",
     "CENTER_ADDRESS": "Sri Chaitanya  School 75\/A, Bannerghatta Road, Hulimavu, bengaluru-560076",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Basavanagudi",
     "CENTER_ADDRESS": "Sri Chaitanya  School #2, B.P Wadia Road, Pandu Towers, Tagore Circle, Basavanagudi, bengaluru-560004",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Davanagere",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Beside Dcm Railway Bridge, P B Road, Davanagere,Bengalore 577003 ",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Electronic City International",
     "CENTER_ADDRESS": "Sri Chaitanya  School Lakshminarayanapura, Behind Apmc Fruit Market, Near Huskurgate, Electronic City, Anekal Taluk, Karnataka - 560099",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Hebbal",
     "CENTER_ADDRESS": "Sri Chaitanya  School,No: 49\/4, Kasaba Hobli, Veeranna Palya Main Road,Nagawara Village,Hebbal, Arabic College Post, bengaluru 560045",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Hsr Layout",
     "CENTER_ADDRESS": "Sri Chaitanya  School #55\/2, 19Th Main, 27Th Cross, Sector 2, Hsr Layout, bengaluru.Pin :560102",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Jp Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School 8Th Phase,Jambu Savari Dinne, Jp Nagar,Bengaluru ",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Kaggadasapura",
     "CENTER_ADDRESS": "Sri Chaitanya  School 121\/4,Vemanna Road,5Th Main, 7Th Cross,Malleshpalaya, Kaggadasapura,Bengaluru -560075",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Kanakapura Road",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey No 11, Near Mantri Tranquil, Gubbalala Village, Kanakapura Road, Bengaluru 560062",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Kr Puram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Shammanna Garden, Devasandra Main Road, Behind Kaveri  Bakery, K.R.Puram, Banglore-560036",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Kudlu",
     "CENTER_ADDRESS": "Sri Chaitanya  School, #429, Prabhu Layout, Aecs Layout, Kudlu, Bengaluru 560068",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Kudlu 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kudlu2  #165,Kudlu Village,Near Parappana Agrahara,Madiwala (P),Benguluru-560068.",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Kudlu Future Pathways",
     "CENTER_ADDRESS": "Sri Chaitanya Future Pathways\n#32\/1, Maruthi Layout,\nNear Shiva Temple,\nKudlu\nBengaluru\n560068",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "M S Palya",
     "CENTER_ADDRESS": "Sri Chaitanya  School 13\/1, Near Ambhabhavani Temple,\nDoddabettahalli, Vidyaranyapura Post\nMspalya - Bengaluru - 560097",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Mahalakshmi Layout",
     "CENTER_ADDRESS": "Sri Chaitanya  School 227, 15Th C Cross Road, 2Nd Phase, Bovipalya, Nagapura, Mahalakshmi Layout,Bengaluru, 560086",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Mangalore",
     "CENTER_ADDRESS": "Sri Chaitanya Tencho School  Bangra Kuloor Road , Kottara Chowki ,Mangalore 576013",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Marthahally",
     "CENTER_ADDRESS": "Sri Chaitanya  School #86\/1C,Near S.G.R Dental College,Munnekolala,Marathahalli-1",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Marthahally 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School # 93\/10, 93\/11, 93\/2A3, 93\/2A4, Munnekolala Village, Beside Shanmukha Restaurant, Near Marathahalli Bridge, Marathahalli, Bengaluru-560037",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Nagarbhavi",
     "CENTER_ADDRESS": "Sri Chaitanya  School 42\/65, Opp Bengaluru University Staff Quarters, Jnanaganga Nagar, Mysore-Magadi Ring Road, Nagarbhavi,Bengaluru 560056",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Peenya Dasarahalli",
     "CENTER_ADDRESS": "Sri Chaitanya  School Surveyno,65\/1,65\/2,Nagasandra  Vilage,Yeshwanthpur Hobli,Bengaluru 560073",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Rajaji Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School #21,(A-108)22, 5Th Main Road, Tndustrial Area, 6Th Block, Rajajinagar, Bengaluru:-560010",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Ram Murthy Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School Seethappa Garden, Raghavendra Circle, T C Palaya Main Road, Ramamurthy Nagar, Bengaluru - 560016",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Ram Murthy Nagar 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey.No. 131\/2, Opp. State Bank Of Mysore, 1St Main, 5 E Cross, Pooja Garden, Ashirwad Colony, Horamavu, Bengaluru 560043",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Ram Murthy Nagar Harivillu",
     "CENTER_ADDRESS": "Sri Chaitanya  School No.91\/1,Hoysala  Nagar,  8Th Main,5Th A Cross,T C Palya  Main Road,Rammurthynagar, Bengaluru 560016 ",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Seshadripuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No:79,Srinivasa Complex, 1St Main Road, Near Fortis Hospital, Seshadripuram, Bengaluru, Karnataka 560020",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Tumkur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Kyathsandra Flyover, Nh-4, Kyathsandra, Tumkur 572104",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Tumkur 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp. Tuda Office Adarshanagar, Sri Sai Baba Tempal Road, Tumkur 572103",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Tumkur 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Sri Sai Baba Temple, Opp Tuda Office, Adharsha Nagar,Tumkur,Karnataka ",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Ullal",
     "CENTER_ADDRESS": "Sri Chaitanya  School 161\/4,Ullal Village,Ullal,Yeswanthpur Hobli,Bengaluru-560056",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Uttarahalli",
     "CENTER_ADDRESS": "Sri Chaitanya  School #27, Arehalli, Ags Layout, Ittamadu Main Road, Uttarahalli, Bengaluru-560061",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Vidyaranyapura",
     "CENTER_ADDRESS": "Sri Chaitanya  School,#21\/3, Ramchandrapura, Vidyaranyapura,Jalahalli Post ,Bengaluru 560013",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Whitefield",
     "CENTER_ADDRESS": "Sri Chaitanya  School,#190, Ans Square, Next To Sathya Sai Complex, Itpl Main Road, Near Hoodi Circle, Hoodi, Whitefield, Bengaluru 560048",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Yellahanka",
     "CENTER_ADDRESS": "Sri Chaitanya  School 30\/2A, Thirumala Nagar, Attur Layout, Near Thirumala Daba, Yelahanka, Bengaluru",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Bengaluru",
     "CENTER": "Yeshwanthpur",
     "CENTER_ADDRESS": "Sri Chaitanya  School #22\/2, Hmr Compund, 6Th Cross, 1St Main, Yeshwanthpur, Bengaluru-560022",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
        "STATE": "Karnataka",
        "CITY": "Bengaluru",
        "CENTER": " Sri Chaitanya Jayanagar Knowledge Hub",
        "CENTER_ADDRESS": "No.123, 24th Main, 30th Cross, 4th Block, Jayanagar, Bangalore - 560011, Karnataka,",
        "Date 1": "09\/18\/2022",
        "Date 2": "10\/09\/2022",
        "Date 3": "10\/16\/2022",
        "Date 4": "11\/13\/2022",
        "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
        "STATE": "Karnataka",
        "CITY": "Bengaluru",
        "CENTER": "Sri Chaitanya Kalyan Nagar Knowledge Hub",
        "CENTER_ADDRESS": "Next to Organic Mandya Farmers Market, 80 feet Road, HRBR Layout, Kalyan Nagar, Bangalore - 560043, Contact :-+91 72079 14068.",
        "Date 1": "09\/18\/2022",
        "Date 2": "10\/09\/2022",
        "Date 3": "10\/16\/2022",
        "Date 4": "11\/13\/2022",
        "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
        "STATE": "Karnataka",
        "CITY": "Bengaluru",
        "CENTER": "Sri Chaitanya Basaveshwara Nagar Knowledge Hub",
        "CENTER_ADDRESS": "PID no 21/97/2, 80 feet Road, KHB 2nd Stage, Basaveshwara Nagar (Near Pavitra Paradise), Bangalore - 560079, Contact :-+91 72079 14069.",
        "Date 1": "09\/18\/2022",
        "Date 2": "10\/09\/2022",
        "Date 3": "10\/16\/2022",
        "Date 4": "11\/13\/2022",
        "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
        "STATE": "Karnataka",
        "CITY": "Belgaum",
        "CENTER": "Sri Chaitanya Belgaum Knowledge Hub",
        "CENTER_ADDRESS": "Krishnai Arcade Tanishq, Opp Tata Croma, khanapur road, Tilakwadi Belgaum - 590006, Contact :-+91 72079 14070.",
        "Date 1": "09\/18\/2022",
        "Date 2": "10\/09\/2022",
        "Date 3": "10\/16\/2022",
        "Date 4": "11\/13\/2022",
        "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Ballari",
     "CENTER": "Ballari",
     "CENTER_ADDRESS": "Sri Chaitanya  School N K B Compound , Back Side Of Bharat Petrol Bunk , Havambhai, Siriguppa Road, Ballari, 583101",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Gangavathi",
     "CENTER": "Gangavathi",
     "CENTER_ADDRESS": "Sri Chaitanya  School C\/O Sapthagiri Public School Near Samarth Koppal Road Waddarhatti Gangavathi-583227  ",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Hospet",
     "CENTER": "Hospet",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside Hampi International Hotel,Railway Station Road ,Hospet Karnataka - 583201",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Hubli",
     "CENTER": "Hubli",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kusugal Road,Near Vrl Residency,Saraswathipuram,Keshawpur,Hubli 580023",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Mandya",
     "CENTER": "Mandya",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp Sanjo Hospital,Srinivasapura, Bm Highway, Mandya,Karnataka",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Raichur",
     "CENTER": "Raichur-3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Ashapur Road, Near Rajmatha Temple, Krishnagiri Hills,Raichur",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Karnataka",
     "CITY": "Sindhanur",
     "CENTER": "Sindhanur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Opp. To Kannika Parameshwari Temple, Pwd Camp, Sindhanur 584128",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Madhya Pradesh",
     "CITY": "Bhopal",
     "CENTER": "Bhopal 1",
     "CENTER_ADDRESS": "Sri Chaitanya  School Oppo. To Pride City,Near Katara Hills,Rapadia Village,Bhopal,Madyapradesh-462043",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Madhya Pradesh",
     "CITY": "Indore",
     "CENTER": "Indore",
     "CENTER_ADDRESS": "Sri Chaitanya  School Krishna Avenue,Near Small Power House,Rani Bagh Main,Khandwa Road,Indore 452001",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Maharashtra",
     "CITY": "Aurangabad",
     "CENTER": "Aurangabad",
     "CENTER_ADDRESS": "Sri Chaitanya  School Dr.Y.S.Kheedkhar International School,Pspm Campus,Near Phistiya Chowk N-6,Cidco Colony ,Aurangabad,Maharastra-431003",
     "Date 3": "10\/16\/2022"
    },
    {
        "STATE": "Maharashtra",
        "CITY": "Mumbai",
        "CENTER": "Andheri Sri Chaitanya Centre",
        "CENTER_ADDRESS": "Sri Chaitanya, 301,B wing. Business point. Paliram road. Andheri west. Near by BMC office Mumbai 400058",
        "Date 3": "10\/16\/2022",
        "Date 4": "11\/13\/2022"
       },
       {
        "STATE": "Maharashtra",
        "CITY": "Mumbai",
        "CENTER": "Borivali Sri Chaitanya Centre",
        "CENTER_ADDRESS": "Brio e-Tech Jr. College & V K Krishna Menon Academy, Plot no. 462, New MHB Colony, Off Gorai Road, Borivali West, Mumbai -400091",
        "Date 3": "10\/16\/2022",
        "Date 4": "11\/13\/2022"
       },
       {
        "STATE": "Maharashtra",
        "CITY": "Mumbai",
        "CENTER": "Thane Sri Chaitanya Centre",
        "CENTER_ADDRESS": "M. H. High School and Junior College, Shivaji Path near Thane station & Talaopali Thane (W)",
        "Date 3": "10\/16\/2022",
        "Date 4": "11\/13\/2022"
       },
    {
     "STATE": "Maharashtra",
     "CITY": "Mumbai",
     "CENTER": "Ulhasnagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kalyan-Murbad Road,Near River Wind Resort,Opposite To Hp Petrol Bunk, Kamba, Kalyan, Ulhasnagar – 421103.",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Maharashtra",
     "CITY": "Pune",
     "CENTER": "Bavadhan",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey No:267\/3, Old Mumbai - Pune Hwy, Near Crystal Honda Showroom, Bavdhan, Pune",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Maharashtra",
     "CITY": "Nanded",
     "CENTER": "Sri Chaitanya Knowledge Hub",
     "CENTER_ADDRESS": "2nd Floor, Lotia Building, Reliance Digital Upstairs,Beside Shivaji Police Station, Shivaji Nagar, Nanded - 431620, Contact :-6301871851.",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Maharashtra",
     "CITY": "Pune",
     "CENTER": "Wagholi",
     "CENTER_ADDRESS": "Sri Chaitanya  School Konark Orchid, Opposite Satav Enterprises, Kesnand Road, Beside Seema Warehouse, Wagholi, Maharashtra 412207",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Maharashtra",
     "CITY": "Pune",
     "CENTER": "Aundh Jaihindh Bldg",
     "CENTER_ADDRESS": " Sri Chaitanya Iit Acadamy,\n4Th Floor  \nJaihindh Building\nParihar Chowk\nArea Aundh\nPune\n411007",
     "PINCODE": 411007,
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Maharashtra",
     "CITY": "Pune",
     "CENTER": "Bavdhan Campus Pune",
     "CENTER_ADDRESS": "Sri Chaitanya Techno School\nNear Crystal Honda Showroom\nMumbai-Pune Highway\nBavdhan(Bk)\nPune\n411021",
     "PINCODE": 411021,
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Maharashtra",
     "CITY": "Pune",
     "CENTER": "Wagholi Campus Pune",
     "CENTER_ADDRESS": "Sri Chaitanya Techno School,\nKonark Orchid,\nGate No . 905,906,926,1085\nOpp. Satav Enterprises,\nBesides Seema Warehouse,\nKesnand Road,\nWagholi,Pune-412207",
     "PINCODE": 412207,
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Maharashtra",
     "CITY": "Pune",
     "CENTER": "Shivaji Bhavan Pun",
     "CENTER_ADDRESS": "Sri Chaitanya Junior College,\nSurvey No 134,Near Xrbia Chowk\nMarunji To Kasarsai Road,\nNere Dattawadi ,\nPost : Jambe,Tal - Mulshi\nPune,Maharashtra-411057",
     "PINCODE": 411057,
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Maharashtra",
     "CITY": "Pune",
     "CENTER": "Saraswathi Sowdham",
     "CENTER_ADDRESS": "Sri Chaitanya Junior College,\n Nandhe Symboysis University(Nawale)\n Near Lopin Compani Gurukul Hostal\n Mulshi Taluka\n Nandhe\n Pune-411042",
     "PINCODE": 411042,
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Punjab",
     "CITY": "Jalandhar",
     "CENTER": "Jalandhar",
     "CENTER_ADDRESS": "Sri Chaitanya  School Eldeco Greens, Nakodar Road, Jalandhar City, Jalandhar - 144026",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Punjab",
     "CITY": "Moga",
     "CENTER": "Moga",
     "CENTER_ADDRESS": "Sri Chaitanya  School Ludhiana Road, Puranewala Village Road, Moga 142001",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Rajasthan",
     "CITY": "Jaipur",
     "CENTER": "Jaipur 1",
     "CENTER_ADDRESS": "Sri Chaitanya  School Kamla Nehru Nagar, Keshu Pura, Near Doungri House, Ajmer Road, Jaipur, Rajasthan, 303006",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Coimbatore",
     "CENTER": "Coimbatore",
     "CENTER_ADDRESS": "Sri Chaitanya  School ,Door No:79, Athipalayam Rd, Near Jas College Of Education, Chinnavedampatti, Coimbatore 641049",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Coimbatore",
     "CENTER": "Coimbatore 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School 806,Wisdom Tree, Kathir Campus,Neelambur,Coimbatore-641062",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Coimbatore",
     "CENTER": "Coimbatore 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School No.11,Dr.Nanjappa Road,  Near Park Gate ,Beside Nehru Stadium,Gandhipuram, Coimbatore  641018",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Coimbatore",
     "CENTER": "Coimbatore 5",
     "CENTER_ADDRESS": "Sri Chaitanya  School S.F.No 22, Lakshmi Nagar, Senamanickenpalayam Road, Idikarai, Coimbatore,Tamil Nadu 641022",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Erode",
     "CENTER": "Erode",
     "CENTER_ADDRESS": "Sri Chaitanya  School 111\/3,Behind Ford Showroom,Nanjanapuram,Thindal,Erode-638012",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Hosur",
     "CENTER": "Hosur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey. No:116\/2, Dinnur Bus Stop, Opp. To Rk Avenue, Behind Fair Mart, Hosur 635109",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Hosur",
     "CENTER": "Hosur 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School F.No:36\/6 & 36\/7, Behind Trend City Layout, Santhapuram Agraharam Village,Via Bagalur Road, Hosur Municipality, Krishnagiri- 635109",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Iyyapanthangal",
     "CENTER_ADDRESS": "Sri Chaithanya  School 16\/2,Evp Park Avenue 2Nd Street Iyyapanthangal Chennai 600056",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Karur",
     "CENTER": "Karur",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey No:113&114, Lns Village, Karur 639002",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Keelkattalai",
     "CENTER_ADDRESS": "Sri Chaitanya  School 2\/1234,Thiru Nagar,Viduthalai Nagar Extn,Kovilambakkam,Keelkattalai,Chennai-600129",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Kk Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School 132 Pillaiyar Koil Street Kasi Estate Jafferkhanpet,Kk Nagar Chennai -600083",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Madhavaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Inner Ring Road ,Housing Sector Madhavram,Chennai-600060",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Manapakkam",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No : 472\/1, Balaraman Street, Thiruvalluvar Nagar, Manapakkam Chennai 600125",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Medavakkam Future Pathways",
     "CENTER_ADDRESS": "Sri Chaitanya  School No: 243,Lake View Road,Surya Nagar Extn.Adjacent To Raj Paris,Bhavani Amman Koil St, Medavakkam. Chennai. Tamil Nadu 600100",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Moolakadai",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey No:1065\/1A1,Ts No.11, Block 58,Kkr Nagar, Madahavaram ,Chennai 600060",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Mylapore",
     "CENTER_ADDRESS": "Sri Chaitanya  School No: 4, Norton Road,Mandaveli,Mylapore,Chennai 600028",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Namakkal",
     "CENTER": "Namakkal",
     "CENTER_ADDRESS": "Sri Chaitanya  School No 3\/19A,Thuraiur Road, Koolitatti Namakaal , Old Sree Mahabharathi Secondary Higher School 637002",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Nolambur",
     "CENTER_ADDRESS": "Sri Chaitanya  School 314\/4, Vgn Nagar Phase 1 3Rd Cross Street, Nolambur, Chennai-600095",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Palavakkam",
     "CENTER_ADDRESS": "Sri Chaitanya  School No:10\/6, Mgr Road, Ecr Palavakkam, Chennai 600041",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Pallavaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School 110 Gst Road, Adjecent Pallavaram Flyover Road, Pallavaram, Chennai 600043",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Pallavaram 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School 200 Feet Radial  Road, Arul Murugan Nagar,Zamin Pallavaram ,Chennai-600043",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Perumbakkam",
     "CENTER_ADDRESS": "Sri Chaitanya  School No 139, Indira Priyadharshini Nagar Layout, Near Global Hospital, Perumbakkam, Chennai 600100",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Perungudi",
     "CENTER_ADDRESS": "Sri Chaitanya  School No 1,44A,Corporation Road,Perungudi,Chennai 600096",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Poonamallee International School",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No :184 Poonamallee To Pattabiram Mainroad,Sokkanallur,Kolappancheri,Chennai 600072",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Ramapuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School 12\/2,12\/3 Anani Sathya Nagar Main Road Thiruvalluvar Salai Ramapuram Chennai-600089 Tamilnadu",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Royapuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School 8\/89, Pudumani Kuppam,West Madha Church Street,Opp Government Unani Hospital,Royapuram,Chennai - 600013.",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Salem",
     "CENTER": "Salem",
     "CENTER_ADDRESS": "Sri Chaitanya  School No.3\/6, N K N Nagar, Perumal Malai Road, Narasothipatty, Kuranguchavadi, Salem 636004",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Tambaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School No.276,Gandhi Nagar.Mudichur Main Road,West Tambaram,Chennai 600063",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Chennai",
     "CENTER": "Thoraipakkam",
     "CENTER_ADDRESS": "Sri Chaitanya  School #104\/8C3, Foundry Road, Okkiyam Thoraipakkam, Chennai - 600097",
     "Date 1": "09\/18\/2022",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
        "STATE": "Tamil Nadu",
        "CITY": "Chennai",
        "CENTER": "Sri Chaitanya Knowledge Hub",
        "CENTER_ADDRESS": "No.19, 1st Main Road, Gandhi Nagar, Above Pantaloons, Adyar, Chennai -600020, Contact :-7207931589 / 7207931590.",
        "Date 1": "09\/18\/2022",
        "Date 2": "10\/09\/2022",
        "Date 3": "10\/16\/2022",
        "Date 4": "11\/13\/2022",
        "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Tiruppur",
     "CENTER": "Tiruppur",
     "CENTER_ADDRESS": "Sri Chaitanya  School No 537 Vivekananda Nagar, College Road, Tiruppur 641603",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Trichy",
     "CENTER": "Trichy",
     "CENTER_ADDRESS": "Sri Chaitanya  School No.1,Kumaran Road,Senthaneerpuram,Near Apollo Hospital,Trichy-620004 ",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Tamil Nadu",
     "CITY": "Velachery",
     "CENTER": "Velachery",
     "CENTER_ADDRESS": "Sri Chaitanya  School #169 Vaigaistreet Devikarumariamman Nagar Extn Velachery -600042",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Ameerpet",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No 8-3-319\/8\/2 To 6&319\/2\/7,Near Saradhi Studios Yousufguda,Main Road Ameerpet Hyd 500073",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Ameerpet 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School No-8-3-222 \/ A\/1,2,3 Plot No-C 57-C 59 Beside Allahabad Bank ( Indian Bank ), Madhura Nagar Yousufguda Main Road ,Ameerpet Hyderabad 500038",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Attapur",
     "CENTER_ADDRESS": "Sri Chaitanya  School 3-4-183\/1, Satti Reddy Complex, Attapur,Rajendra Nagar, Hyderabad",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Jubilee Hills",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No - 367&368 , Kakateeya Hills (Kavuri Hills),  Road No -8,  Madhapur , Jubilee Hills ,  Gutala Begumpet , Sherilingampally Mandal, Ranga Reddy Distrit - 500081",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Manikonda",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey No:143,145,149,Jaya Abode,Opp:Andhra Bank,Secretariat Colony,Manikonda 500089",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Shamshabad",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey No 578\/A582\/A,Adarsh Nagar,Shamshabad, Rangareddy",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sr Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School Door.No.7-1-621\/280 & 281,254 & 255-3Rt, Sr Nagar Main Rd, Above Sbh Bank, Sanjeeva Reddy Nagar, Hyderabad, Telangana,500038.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sun City",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No: 1-2\/1, Shanthi Nagar Colony, Hydershakote, Suncity, Rr. Dt- 500091",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Tolichowki",
     "CENTER_ADDRESS": "Sri Chaitanya  School 8-1-22\/1\/M, 7 Tombs Road,Opposite Golden Palace,Function Hall,Tolichowki, Hyderabad",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Chaitanyapuri Cbse",
     "CENTER_ADDRESS": "Sri Chaitanya  School Pananiya Mahavidyalaya Public School,Opp Thankur Hari Prasad Institute,Chaitanyapuri,Dilsuknagar",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Dilsuknagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No:3-10\/A,Hanumannagar,Beside Pakala Plaza,Opp.Saptagiri Hospital,Chaitanyapuri,Hyderabad.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Gaddi Annaram",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No.16-2-752\/123\/1\/123\/A&4A, Shiva Ganga Theatres Road, Beside: Sbh Bank, Gaddiannaram, Hyd-500060",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Gayathri Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No: 2&131, Near  Gayathrinagar X Roads, Beside Sbi Bank, Gayathrinagar, Jillalaguda,Dilsukhnagar",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Hayatnagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No:60,64 & 67,71 Khalsa, Hayathnagar Rr(Dt) 501505",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Hayatnagar 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot. No. 5,6,7,8,9 & 10,Khalsa,Hayathnagar,Rangareddy 501505",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Keshavapuri",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No: 8-7-92\/K, Keshavapuri Colony, Sagar Road, Hastinapuram,Hyderabad Telangana",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Khalsa",
     "CENTER_ADDRESS": "Sri Chaitanya  School Near Hiway Bawachi Hotel Line,Suguna Enclave,Khalsa,Hayatnagar-501505",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kharmanghat",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No:7,Srinivasa Nagar Colony,Opp:Uco Bank,Kharmanghat,Hyderabad 500035",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kothapet",
     "CENTER_ADDRESS": "Sri Chaitanya  School D.No.23-38\/2&3,Krishnaveni Nagar,Opp:Fruitmarket Lane,Near Ghmc East Zonal Office,Kothapet,Dilsuknagar,Hyderabad,R.R.Dist-60.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "L.B.Nagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No.3-11-282,Shiva Ganga Colony,Opp. Big Bazar,Lbnagar,Hyderabad.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "L.B.Nagar 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No: 3-11-461\/A Part, Road No: 2,\nShiva Ganga Colony ,Mansoorabad, L.B Nagar,\nHyderabad,\nTelangana",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Mansoorabad",
     "CENTER_ADDRESS": "Sri Chaitanya  School Beside Sai Baba Temple,Kamineni Hospital Bypass Road,Laxmi Nagar Colony,Mansoorabad,Hyderabad-500074",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Meerpet",
     "CENTER_ADDRESS": "Sri Chaitanya  School  P.No:1234.Opp:Y Jr Function Hall,Tmr Enclave ,Near Meerpet Cross Road,Badangpet Hyderabad 500097",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Moosarambagh",
     "CENTER_ADDRESS": "Sri Chaitanya  School H No:16-11-469\/A\/1 To 12,Opp Sbi Officers Colony Park, Sbi Officers Colony,Moosarambagh Dilsukhnagar,500036",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Nagole",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot.No 46&47, Road No.5, Sai Nagar Colony, Opp. Alkapuri Signal, Nagole",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sai Nagar Colony",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Survey No:13,23 & Part Of-25,Opp:Radio Station Tower,Vijayawada Highway,Kalasa,Sai Nagar Colony,Hayath Nagar-501505",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vanasthalipuram",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No.288, Door No.5-5-285, Near Sri Kanakadurga Temple, Prashanth Nagar, Vanasthalipuram, Hyderabad 500070",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Hmt Colony",
     "CENTER_ADDRESS": "Sri Chaitanya  School Flot No :59&60,Ht Line,Hmt Colony,Alwal,500010",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kompally",
     "CENTER_ADDRESS": "Sri Chaitanya  School,Gundlapochampally,Beside Gvk Emri,Near Prestige Park,Medchal",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kompally 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School Mlr Complex,Beside Bharath Petrol Bunk,Kompally,Hyderabad",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kompally 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School Chandrareddy Gardens Survey No: 87, Mahalakshmi Enclave Road,Near Dhola-Ri- Dhani, Kompally, Hyderabad,Telangana- 500014",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kompally 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey.No.85 Beside S.N.R Garden, Kompally 500014",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kompally 5",
     "CENTER_ADDRESS": "Sri Chaitanya  School Mahalakshmi Enclave, Beside Navatha Transport, Near Dola Ri Dani, Kompally, Medchal - 500014",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Medchal",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No: 36,37,64,Opp Seven Temples,Uma Nagar, Medchal,Hyderabad ",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Toopran",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey No-455, Allapur Road, Toopran,Kompally 502334",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Beeramguda",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Green Meadows Main Road, Esuka Bavi, Beeramguda, Ameenpur (Mdl), Sangareddy (Dst) 502032",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Chintal",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No 145\/P Opp Hp Gas Agency Patwari Enclave Idpl Chintal 500054",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Gachibowli",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No :338 To 342\nRoad No : 9\nBhagya Laxmi Nagar, Phase 2\nOpp To Ghmc\nLegala Circle Road,Kondapur\nGachibowli\nSerilingampally\nHyderabad\n500019\n",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kukatpally",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No 6 ,Balaji Nagar, Near Metro Station Kukatapally,Hyderabad ",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kukatpally 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School 5-3-114, Plot No 1 & 14, Behind Reliance Smart, Shanti Nagar,Near Ramalayam, Kukatpally, Hyderabad 500072",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Nallagandla",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Opp Aparna Cyber Life,Nallagandla(Vill), Rangareddy(Dist) 500019",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sangareddy",
     "CENTER_ADDRESS": "Sri Chaitanya  School Aphb Colony Opp New Collectorate, Sangareddy 502001",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Serilingampally",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No.20 & 21, Huda Lay Out, Near Ajay Function Hall & Lingampally Rythu Bazar,  Serilingampally Ranga Reddy ",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Seven Hills",
     "CENTER_ADDRESS": "Sri Chaitanya  School 1-2-46\/348,Anjanadri Block,Sevenhills Apartments,Nizampet X Road,Besid Sri Sri Holistic Hospital,Hyd,500085",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sp Nagar Ds",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plotno:3&4,Sardarpatel Nagar,Nizampet X Raod,Hydernagar,Hyderbad 500085",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sp Nagar Res",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No 175,Near Jntu Metro Station ,Sardar Patel Nagar, Kukatpally 500085",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vv Nagar Ds",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot.No. 157,158 &159, Beside Ramalayam, Sapthagiri Colony, Vivekanandanagar, Kukatpally, Hyderabad 500072",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vv Nagar Res(Boys)",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plotno.28,29, Sapthagiri Colony,Vivekanandanagar,Kukatpally 500072",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Banjarahills Starkidspremium",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No 8-2-310-B-10, Road No 14, Navodaya Colony, Nandi Nagar, Banjara Hills,Hyderabad 500034",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Bowenpally",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No. 1-4, Chinnathokatta, New Bowenpally, Secunderabad 500011",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "East Maredpally",
     "CENTER_ADDRESS": "Sri Chaitanya  School 10-3-18\/4,Opp: Bank Of Baroda(Formerly Dena Bank),,East Maredpally,Hyderbad-5000026",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Ecil 3",
     "CENTER_ADDRESS": "Sri Chaitanya  School A8, Tulasi Hospital Line,Electronic Complex, Ecil,Kushaiguda, Hyderabad - 500062",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Ecil 4",
     "CENTER_ADDRESS": "Sri Chaitanya  School P.No:A\/10, Electronic Complex, Phase 2,Kushaiguda, Ecil 'X' Roads Mehdipatnam 500062",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Gosha Mahal",
     "CENTER_ADDRESS": "Sri Chaitanya  School D No.5-3-825,Mallakunta Road, Opp. New Ioc Petrol Pump,Goshamahal,Hyderabad,500012",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Hasmathpet",
     "CENTER_ADDRESS": "Sri Chaitanya  School Survey No 1, Seetha Ramapuram, Mallareddy Garden Lane,Beside Kalyani Theatre, Old Bowenpally Hasmathpet 500011",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Hyderguda",
     "CENTER_ADDRESS": "Sri Chaitanya  School Pillar No -118 ,Hanuman Temple Lane , Sri  Laksmi Nagar Colony, Street No -03 ,Near Indian Bank Back Side & Close To Janapriya Utopiya Apartments, Hyderguda Attapur - 500048",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Karkhana",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No 144\/149, Text Book Colony ,Transport Road,Karkhana,Secunderabad. Telangana-500009",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Lal Darwaj",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No.18-4-42\/3\/2, Andhra Bank Lane,Lal Darwaj ,Hyderabad  500065",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "M G Road",
     "CENTER_ADDRESS": "Sri Chaitanya  School # 2 - 4- 73\/74 , Beside Kfc, Mg Road, Nallagutta, Secunderabad -500003",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Mehdipatnam",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No: 3 , Santosh Nagar Colony, St.Ann'S Women'S College Road, Mehdipatnam, Hyderabad - 500028",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Barkatpura",
     "CENTER_ADDRESS": "Sri Chaitanya  School Hno: 3-4-760, Beside Andhra Yuvathi Mandal, Barkatpura, Hyderabad, Telangana 500027",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Ghatkesar",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No-9-165,Opp Ioc Petrol Bunk,Near Electricity Sub Station,Main Road, Ghatkesar-501301",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Habsiguda 2",
     "CENTER_ADDRESS": "Sri Chaitanya  School 1-7-34\/7 & 4\/Nr, Opp Christ The King Church, Beside Badras Grand Hotel, Ramanthapur,Habsiguda, Uppal(M), Medchal (D)",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Himayatnagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School 3-6-655Road9,Ashoknagar.Himayatnagar,Narayanguda,Hyderabad",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Medipally",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No: 13-238, Opp.Hanuman Temple,Main Road Medipally Villege,Medchal Dist-500098",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Nacharam",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No 17\/4 , Survey No: 45 & 46 , Nacharam ,Uppal Mandal,Medchal 500076",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Nallakunta",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No:1-9-1104 To 1112,Opp Lane To Durgabai Deshmukh Hospital,Vidyanagar,Adikmet,Nallakunta, Hyderabad-500044",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Nallakunta Dd Colony",
     "CENTER_ADDRESS": "Sri Chaitanya  School Hno 2-1-63\/3,Surya Nagar Colony ,Malkajgiri Dt Uppal (M)Medchal, Telangana 500039",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Taranaka",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No-12-5-28\/29\/2,Tarnaka,Secunderabad-500017.",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Madhapur Ipl",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plot No:3-510,Opposite Ysr Statue,Vivin Backside,Ayyappa Society,Madhapur 500080",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Ramagundam",
     "CENTER_ADDRESS": "Sri Chaitanya  School-Fertilizer City,Rfcl Township, Rfcl, Ramagundam-Peddapally(Dist) 505210",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Kodad",
     "CENTER": "Starkids Kodad",
     "CENTER_ADDRESS": "Sri Chaitanya  School, Star Kids Campus, Ganesh Nagar,Current Office Back,Kodad, Suryapet (Dist) 508206",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Kodad",
     "CENTER": "Talent Ds",
     "CENTER_ADDRESS": "Sri Chaitanya  School H.No.3-237\/3, Srinagar Colony,Kodad Post & Mdl,  Suryapeta Dt 508206",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Kodad",
     "CENTER": "Talent Rs",
     "CENTER_ADDRESS": "Sri Chaitanya  School Sana Engineering College Kodad Post & Mdl, Kodad Suryapeta 508206 ",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Kukatpally",
     "CENTER": "Miyapur Future Pathways",
     "CENTER_ADDRESS": "Sri Chaitanya  School Plat No 9216, Opp Ingine Oil Petrol Bunk Miyapur X Road Miyapur Hyderabad 500049",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Mehdipatnam",
     "CENTER": "Dammaiguda",
     "CENTER_ADDRESS": "Sri Chaitanya  School Anjanadri Nagar, Extension Opp Lake View Water Tank, Dammaiguda Medchal 500083",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "L B Nagar Zonal",
     "CENTER_ADDRESS": "H.No:3-6-260,L B Nagar,Sbi Bank Colony,Venture -1",
     "PINCODE": 500060,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "R.K.Puram Semi Resi",
     "CENTER_ADDRESS": "H.No:11-13-1106&1107,Near Victoria,Memorial Metro Station,Green Hills Colony",
     "PINCODE": 500035,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Satyasai",
     "CENTER_ADDRESS": "H.No:18-98,Kamala Nagar,Chaitanyapuri,Dilsukhnagar",
     "PINCODE": 500060,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "R K Puram-2",
     "CENTER_ADDRESS": "Road No-1,Greenhills Colony,Kothapet",
     "PINCODE": 500035,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Manisha",
     "CENTER_ADDRESS": "D.No:1-69,Plot No 24,Manisha Complex,Prabath Nagar,Chaitanyapuri",
     "PINCODE": 500060,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Dsnr Zonal Days",
     "CENTER_ADDRESS": "Saibaba Temple Line,P & T Colony,Beside Sanjay Steel,Dilsukhnagar",
     "PINCODE": 500060,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Jella Arcade  R K Puram Ltc",
     "CENTER_ADDRESS": "Metro Station L Bnagar,Sbi Colony,Kothapet,Hyderabad,Ts",
     "PINCODE": 500035,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Ramanujam Bhavan Bongulor",
     "CENTER_ADDRESS": "D:No 5-105, Sy.No:109(Part), Old Jnit Engg College, Bongulur X Roads, Mangalpalli-Patelguda",
     "PINCODE": 501510,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vyasa Bhavan Adibatla",
     "CENTER_ADDRESS": "Survey No 163\/Aa, Of Bonguluru Village, Ibrahimpatnam Mandal, Rangareddy Dist",
     "PINCODE": 501510,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Lbnagar",
     "CENTER_ADDRESS": "H No 3-1-33, Bahadurguda, Lbnagar",
     "PINCODE": 500074,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vydehi Bhavan Autonagar",
     "CENTER_ADDRESS": "284 (Western Part), Nakka Venkata Swamy Yadav Nagar, Bagh Hayathnagar",
     "PINCODE": 500070,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Uppal Res Boduppal Campus",
     "CENTER_ADDRESS": "H No 12-165\/9, Peerzadiguda, Uppal",
     "PINCODE": 500098,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Uppal Res Boduppal Campus",
     "CENTER_ADDRESS": "H No 12-165\/9, Peerzadiguda, Uppal",
     "PINCODE": 500098,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Nagole Girls",
     "CENTER_ADDRESS": "Nagole Enclave,Bahadurguda",
     "PINCODE": 500074,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Rvhouse",
     "CENTER_ADDRESS": "H.No 11-13-644\/2-Haripuri Colony, Road No :3  Alkapur-Nagole, Hyd-35",
     "PINCODE": 500035,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Bandlaguda",
     "CENTER_ADDRESS": "H.No 196, Arunodhaya Colony, Bandlaguda Road Nagole, Hyd-35",
     "PINCODE": 500068,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Heritage Building",
     "CENTER_ADDRESS": "Plot No. 62, Survey No 93 Arunodayanagar Rd.No 6 Nagole ",
     "PINCODE": 500068,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Boduppal Boys  Mpc Res",
     "CENTER_ADDRESS": "Boduppal",
     "PINCODE": 500098,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sushrutha Bhavan Medipally Campus",
     "CENTER_ADDRESS": "Medipally",
     "PINCODE": 500098,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Ghatkesar",
     "CENTER_ADDRESS": "Sy No-265\n Aushapur,Ankushapur Post\n\n",
     "PINCODE": 501301,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Pananiya",
     "CENTER_ADDRESS": "Sy No 103,Block 2B,Vvnagar,Gaddinnaram",
     "PINCODE": 500060,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Akshara",
     "CENTER_ADDRESS": "H.No: 7-1-621\/279, 256\/M6, Beside Axis Bank, Sr Nagar, Hyderabad-500038",
     "PINCODE": 500038,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Amrutha",
     "CENTER_ADDRESS": "H.No: 7-1-621\/550, 516\/3Rt, Sr Nagar, Hyderabad-500038",
     "PINCODE": 500038,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Niraja Campus (Ca Campus)",
     "CENTER_ADDRESS": "H.No: 8-3-191\/2P, 27\/A, Sr Nagar, Hyderabad-500038",
     "PINCODE": 500038,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Aryabhatta",
     "CENTER_ADDRESS": "7-1-414\/35(B), Ameerpet,Hyderabad-500038",
     "PINCODE": 500038,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Bhaskar Bhavan",
     "CENTER_ADDRESS": "7-1-621\/260\/B, Sr Nagar , Hyderabad-500038",
     "PINCODE": 500038,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Adarsha",
     "CENTER_ADDRESS": "Hno: 7-1-621\/298, Pno: 277\/3Rt, S R Nagar, Hyderabad-500038",
     "PINCODE": 500038,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Saraswathi",
     "CENTER_ADDRESS": "H.No: 7-1-217\/A, Balkampet, B K Guda, Sr Nagar, Hyderabad-500038",
     "PINCODE": 500038,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Yousufguda",
     "CENTER_ADDRESS": "H.No: 8-3-318\/6\/6, Bandaru Bhavan, 2Nd Floor, Yousufguda, Hyderabad-500073",
     "PINCODE": 500073,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Jubilee Hills",
     "CENTER_ADDRESS": "H.No: 8229382\/J111\/573 G, Rajiv Bhavan, Jubilee Hills, Opp: Kbr Park, Gate No 6, Road No -1, Jubilee Hills, Hyderabad-500096",
     "PINCODE": 500096,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Attapur",
     "CENTER_ADDRESS": "Pillar No: 143, H.No: 3-4-183\/1, Attapur, Rajendra Nagar, Ranga Reddy District-500048",
     "PINCODE": 500048,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Srinivasa Complex",
     "CENTER_ADDRESS": "Srinivasa Complex 2Nd Floor, Beside Bus Stop, Kukatpally, Hyd",
     "PINCODE": 500072,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Saraswathi Bhavan ",
     "CENTER_ADDRESS": "H No: 5-4-59\/2\/1 Saraswathi Bhavan, Near Genesis High School, Sangeeth Nagar, Kukatpally, Hyd ",
     "PINCODE": 500072,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Srividya Bhavan",
     "CENTER_ADDRESS": "H No 5-4-58\/9\/1 & 5-5-7\/10\/1, Plot No 7 & 8, Kukatpally",
     "PINCODE": 500072,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sai Vikram Towers",
     "CENTER_ADDRESS": "Sai Vikram Towers, 3Rd Floor, Beside Metro Station, Kukatpally,Hyd",
     "PINCODE": 500072,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Bhaskar Bhavan",
     "CENTER_ADDRESS": "Bhaskar Bhavan, Omni Hospital Back Side, Balaji Nagar, Kukatpally, Hyd",
     "PINCODE": 500072,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sri Bhaskar Bhavan",
     "CENTER_ADDRESS": "Sri Bhaskar Bhavan, Above Nexa Car Showroom, A S Raju Nagar, Kukatpally, Hyd",
     "PINCODE": 500072,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Raman Bhavan",
     "CENTER_ADDRESS": "Raman Bhavan, Bhagya Nagar Co-Operative Society , Shiva Parvathi Theater Raod, Opp Kphb, Hyd",
     "PINCODE": 500072,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vagdevi Bhavan",
     "CENTER_ADDRESS": "Vagdevi Bhavan, Phase I, Beside Mro Office, Kphb Colony, Hyd",
     "PINCODE": 500072,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Patwari Bhavan",
     "CENTER_ADDRESS": "Plot No: 5, Patwari Enclave, Opp Ipdl Colony, Chintal, Hyd",
     "PINCODE": 500037,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vasavi Bhavan",
     "CENTER_ADDRESS": "Apiic Colony, Opp Idpl Colony, Quthbullapur, Hyd",
     "PINCODE": 500037,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vyas Bhavan",
     "CENTER_ADDRESS": "Spring Field Colony, Near Good Shepherd School, Suchitra, Quthbullapur, Hyd",
     "PINCODE": 500055,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Bharathi Bhavan",
     "CENTER_ADDRESS": "Bharathi Bhavan, Plot No: 5,6 & 7, Behind Max Shopping Mall, Madinaguda, Hyd",
     "PINCODE": 500049,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sharadha Bhavan",
     "CENTER_ADDRESS": "Sri Chaitanya Jr College, 1-58\/A\/8\/1, Rama Krishna Colony, Beside Naidu Eye Hospital, Madinaguda, Hyd",
     "PINCODE": 500049,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vasista Bhavan",
     "CENTER_ADDRESS": "Above Unlimted, Madinaguda Showroom",
     "PINCODE": 500049,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vasuda Bhavan",
     "CENTER_ADDRESS": "Back Side Kajana Jewelers, Madinaguda",
     "PINCODE": 500049,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Surya Towers",
     "CENTER_ADDRESS": "Plot No: 5-14, Surya Towers, Chanda Nagar ",
     "PINCODE": 500050,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Jai Hind Complex",
     "CENTER_ADDRESS": "Plot No 53 To 63 H No: 5-88\/2 Near Zph School Manikonda, Hyd ",
     "PINCODE": 500089,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Soudamini Bhavan",
     "CENTER_ADDRESS": "4-94, Chanda Nagar",
     "PINCODE": 500019,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Hydernagar Boys",
     "CENTER_ADDRESS": "Syno . 1598169\/2 Sri Chaitanya Jr College, Hydernagar Boy Campus, Manjeera Water Work Road, Near Calavery Temple, Hyd",
     "PINCODE": 500049,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "A K Bhavan Ameenpur",
     "CENTER_ADDRESS": "Flot No \/ Plot No \/ Survey No :330(P) & 341(P) Street Name  :Sai Anuragcolony Area Name   :Sai Anurag Colony  Near By Land Mark  Opp Volo Service Center City -Hydrabad  , Pincide -500090",
     "PINCODE": 500090,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Bowrampet Ipl",
     "CENTER_ADDRESS": "Flot No \/ Plot No \/ Survey No -Police Chandra Reddy Avlon Street Name -Simhapuri Colony Area Name -Bowrampet Near By Land Mark -Pragathinagar Kamman  Pposite City - Hyderabad\nPincide -500090",
     "PINCODE": 500090,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Agastya Sri Bhavan",
     "CENTER_ADDRESS": "Campus Name- Agastya Sri Bhavan Street- Bowrampet Area- Bowrampet Landmark- Near Hamara Dhaba , Opp Ioc Petrol Bunk City- Hyderabad Pin Code- 500043.",
     "PINCODE": 500043,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Agastya Sri Bhavan-1 A\/C",
     "CENTER_ADDRESS": "Sri Chaitanya Junior Kalasala Agastya Sri Bhavan-1 Ac Survey No:  166\/6 Near Oakridge International School  Bowrampet Dundigal Gandimaisamma Mandal Medchal Istrict \nPin Code:  500043 ",
     "PINCODE": 500043,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Bowrampet Ias",
     "CENTER_ADDRESS": "Sri Chaitanya Ias Academy -  Dundigal Gandimaisamma Mandal, Bowrampet, Medchal - 500004 \nSurvey No - 476, \nNear Drk Engineering College, Bowrampet",
     "PINCODE": 500004,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Hydernagar Zonal",
     "CENTER_ADDRESS": "Flot No \/ Plot No \/ Survey No -68 Street Name - Sardar Patel Nagar Area Name - Nizampet X Road  Near By Land Mark -Coumunity Hall City - Hyderabad Pincide -500072\n",
     "PINCODE": 500072,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kphb Res Pratibha Bhavan",
     "CENTER_ADDRESS": "Kphb Res Pratibha Bhavan,Sri Chaitanya Junior Kalasala, Dharma Reddy Colony,Kphb Phase -3,Near Lotus Hospital Beside Street ,Near To Opposite Pratibha School,Jntu, ",
     "PINCODE": 500085,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Madinaguda Ias",
     "CENTER_ADDRESS": "Flot No \/ Plot No \/ Survey No - 1218\/E2-1\/2012-2013, 122, 127, 128,  Street Name -Sri Chaitanya Ias Acdemy,Opp Pranam Hospital Area Name -Madinaguda Near By Land Mark - Ijetha Degree College\nCity - Hyderabad\nPincide -500050",
     "PINCODE": 500050,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Nizampet Boys Mytas",
     "CENTER_ADDRESS": "Plot No:1-25\/Arka Bhavan Nizampet (Vi)Bachupally(M.D)Medchal(D.T)",
     "PINCODE": 500049,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Pragathi Bhavan Nizampet",
     "CENTER_ADDRESS": "Plot No:1-25\/Arka Bhavan Nizampet (Vi)Bachupally(M.D)Medchal(D.T)",
     "PINCODE": 500049,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Pragathi Nagar Medical Academy",
     "CENTER_ADDRESS": "Sri Chaitanya Junior Kalasala (R.C.No.2015\/E2-1\/2005-2006,Date:21-11-2005) College Code:59325, Sri Sahasra Bhavan, Plot No.8-123, Sy No.145\/A,Pragathi Nagar, Bachupally(M), Medchal(Dist),\nHyderabad. Pin Code:500090",
     "PINCODE": 500090,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Prathibha Sai Nagar Hyd",
     "CENTER_ADDRESS": "Flot No \/ Plot No \/ Survey No -16-2-132\/135\/231 Street Name -K V R Complex,Nizampet Cross Road Area Name -Sainagar Colony Near By Land Mark -Lucid Diagnastics City - Hyderabad\nPincide -500085",
     "PINCODE": 500085,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Charaka Bhavan",
     "CENTER_ADDRESS": "Plot No 257, Bowrampet, Gandimisamma",
     "PINCODE": 500043,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Mihira Bhavan A\/C Res",
     "CENTER_ADDRESS": "Opposite Hdfc Bank,Sanford School,Srila Gardens,Surksha Hospitals,Srilaxmi Nivas",
     "PINCODE": 500049,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Parasara Bhavan",
     "CENTER_ADDRESS": "Sreenivasam Building,Opp Pride Honda Service Showroom,Beside Navatha Transport,Bollaram Road,Miyapur",
     "PINCODE": 500049,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Sri Sai Darbhar",
     "CENTER_ADDRESS": "H.No.1-62\/Sd\/5To 8\/1,Plot No.5678,Sy No:198\/2\/A, Sri Aurobindo Colony",
     "PINCODE": 500049,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Saraswathi Soudham Rudraram",
     "CENTER_ADDRESS": "Sarvey No 35 Old Gitams Building Rudraram",
     "PINCODE": 523001,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Aditya Bhavan",
     "CENTER_ADDRESS": "1-2-31 Aditya Bhavan Nizampet Road",
     "PINCODE": 500085,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Tarnaka (Main Campus)",
     "CENTER_ADDRESS": "H No 12-5-1\/1, Jaya Towers, Opp White House Bus Stop, Tarnaka, Secunderabad",
     "PINCODE": 500017,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Tarnaka (Hari Hara Heights)",
     "CENTER_ADDRESS": "H No 12-13-1210\/1, Street No 10, Tarnaka, Secunderabad",
     "PINCODE": 500017,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Habsiguda",
     "CENTER_ADDRESS": "H No 6-10-8\/1\/1, Nagendra Nagar, Habsiguda",
     "PINCODE": 500007,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Ramanthapur",
     "CENTER_ADDRESS": "3-9-29, Sharada Nagar, Adrm Hospital Lane, Ramanthapur",
     "PINCODE": 500013,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Main Campus",
     "CENTER_ADDRESS": "3-5-947 &948, Opp.Tajmahal Hotel, Sudarshan Building, Narayanaguda",
     "PINCODE": 500029,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Iit Campus",
     "CENTER_ADDRESS": "3-5-947 & 948, 3Rd Fllor,Opp.Tajmahal Hotel, Sudarshan Building, Narayanaguda",
     "PINCODE": 500029,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "2Nd Campus",
     "CENTER_ADDRESS": "H.No.3-5-1082, 3-5-1082\/3, 3-5-1082\/11\/C, Kesava Memorial School Lane, Narayanaguda, Hyderabad",
     "PINCODE": 500029,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Girls Campus",
     "CENTER_ADDRESS": "3-6-772, Beside Petrol Bunk And Taj Mahal Hotel,Himayathnagar,Hyd",
     "PINCODE": 500029,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "4Th Campus",
     "CENTER_ADDRESS": "H.No.3-4-697 And 3-4-700, Near Flyover, Narayanaguda Cross Roads, Hyderabad",
     "PINCODE": 500029,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vyas Bhavan",
     "CENTER_ADDRESS": "3-4-703,Near Flyover, Narayanaguda Cross Roads, Hyderabad",
     "PINCODE": 500029,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Balaji Arcade ",
     "CENTER_ADDRESS": "Near Chikkadpally Metro, Above Ramraj Cotton, Hyd",
     "PINCODE": 500029,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "City Plaza",
     "CENTER_ADDRESS": "D.No.3-6-614,Himayathnagar Junction, Above Santosh Family Daba, 3Rd Floor, Hyd, 500029",
     "PINCODE": 500029,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Jhansi Soudham Hyd",
     "CENTER_ADDRESS": "Vattinagulapally",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Kondapur Ipl Girls",
     "CENTER_ADDRESS": "Opp Kims Hospital, Kondapur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Madhapur Vagdevi Ipl",
     "CENTER_ADDRESS": "Madhapur",
     "PINCODE": 500081,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Saradha Campus Hyd",
     "CENTER_ADDRESS": "Madhapur",
     "PINCODE": 500081,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Saraswathy Boys",
     "CENTER_ADDRESS": "Madhapur",
     "PINCODE": 500081,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Saraswathy Girls",
     "CENTER_ADDRESS": "Madhapur",
     "PINCODE": 500081,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Valmiki Bhavan Kondapur",
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vivin Towers",
     "CENTER_ADDRESS": "Madhapur",
     "PINCODE": 500081,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Medhaswi Bhavan Narsingi",
     "CENTER_ADDRESS": "Plot No 308 309 311 Near Ysr Statue Opposit Mallana Swamy Temple Narsingi Village Rajendranagar Mandal, Rangareddy Pin Code 500075",
     "PINCODE": 500075,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Ramanbhavan Ii Narsingi",
     "CENTER_ADDRESS": "3-6\/9\/3, Plot No. 349 To 360, Mahathi Building, Behind Kvmr Function Hall       Narsingi Municipality , Gandipet  Mandal, Ranga Reddy District-500075 ",
     "PINCODE": 500075,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vedavyas 1",
     "CENTER_ADDRESS": "Plot No. 319, 320  Beside. H.P. Petrol Pump, Narsingi,  Gandipet Md Ranga Reddy Dt",
     "PINCODE": 500075,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Telangana",
     "CITY": "Hyderabad",
     "CENTER": "Vidyabhavan Narsingi ",
     "CENTER_ADDRESS": " Neyar  Mallana Swamy Temple Narsingi Village Rajendranagar Mandal, Rangareddy ",
     "PINCODE": 500075,
     "Date 2": "10\/09\/2022",
     "Date 3": "10\/16\/2022",
     "Time Slot": "Grade 1-8 (10-11:30am), Grade 9-13 (10-1pm)"
    },
    {
     "STATE": "Uttar Pradesh",
     "CITY": "Agra",
     "CENTER": "Agra",
     "CENTER_ADDRESS": "Sri Chaitanya  School Bodla-Bichpuri Road, Near Shastri Puram, Agra - 283 105",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Uttar Pradesh",
     "CITY": "Firozabad",
     "CENTER": "Firozabad",
     "CENTER_ADDRESS": "Sri Chaitanya  School Nh 2 , Behind Bishan Dhaba And Petrol Pump, Near Usaini, Tundla ,Firozabad 283103",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "Uttar Pradesh",
     "CITY": "Lucknow",
     "CENTER": "Lucknow",
     "CENTER_ADDRESS": "Sri Chaitanya  School Adjacent To Flyover, Amethiya, Hardoi Road, State Highway 25,Lucknow Uttar Pradesh 2260101\n\n",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Uttar Pradesh",
     "CITY": "Meerut",
     "CENTER": "Meerut",
     "CENTER_ADDRESS": "Sri Chaitanya  School 6Th Mile Stone, Mawana Road,Meerut,Uttar Pradesh 250001",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "Uttar Pradesh",
     "CITY": "Muzaffarnagar",
     "CENTER": "Muzaffarnagar",
     "CENTER_ADDRESS": "Sri Chaitanya  School Nh-58, Bibipur, Block Sadar,Muzaffarnagar,Uttar Pradesh  251001 ",
     "Date 3": "10\/16\/2022"
    },
    {
     "STATE": "West Bengal",
     "CITY": "Kolkata",
     "CENTER": "Bada Bazar",
     "CENTER_ADDRESS": "Sri Chaitanya  School 2A,Nanda Mullick Lane, Near Ganesh Talkies ,  Burra Bazar,  Kolkata-700006",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "West Bengal",
     "CITY": "Kolkata",
     "CENTER": "Dunlop",
     "CENTER_ADDRESS": "Sri Chaitanya  School 51, S.M.Bose Road (Lahabagan), Near Duck Back More , Panihati,Kolkata-700114",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "West Bengal",
     "CITY": "Kolkata",
     "CENTER": "New Town",
     "CENTER_ADDRESS": "Sri Chaitanya  School 06-360, Street No: 360, Beside Rishi Tech Park, Newtown, Kolkata-700160",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
     "STATE": "West Bengal",
     "CITY": "Kolkata",
     "CENTER": "Serampore",
     "CENTER_ADDRESS": "Sri Chaitanya  School Jannagar Rd, Mahesh Colony, Near Tennis Club, Serampore, Hooghly-712202",
     "Date 1": "09\/18\/2022",
     "Date 3": "10\/16\/2022",
     "Date 4": "11\/13\/2022"
    },
    {
        "STATE": "Chandigarh",
        "CITY": "Chandigarh",
        "CENTER": "Sri Chaitanya Centre",
        "CENTER_ADDRESS": "SCO 369-70, Sector 34A, Chandigarh, India",
        "Date 1": "09\/18\/2022",
        "Date 3": "10\/16\/2022",
        "Date 4": "11\/13\/2022"
    },
    {
        "STATE": "Haryana",
        "CITY": "Panchkula",
        "CENTER": "Sri Chaitanya Centre",
        "CENTER_ADDRESS": "SCO 219, 2nd Floor, Sector 14, Panchkula",
        "Date 1": "09\/18\/2022",
        "Date 3": "10\/16\/2022",
        "Date 4": "11\/13\/2022"
       }
   ]